export const othersWorkshops = [
  {
    "Unique ID": 662,
    Name: "Bengkel Memateri Kenderaan Tek Yee Sdn Bhd",
    Address:
      "Ptd 11769, Jalan Industri 2\nTmn Perindustrian\n81500\nPekan Nanas\nJohor Darul Takzim",
    Tel: "07- 699 2207\n07- 699 1803",
    Fax: "07- 699 6520",
    Email: "tekyee@yahoo.com",
    Area: "PEKAN NANAS",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 663,
    Name: "Eng Hong Welding Workshop Sdn Bhd",
    Address:
      "Lot 738 (Pos 50)\nJalan Jeram Tepi Bakri\n84000\nMuar\nJohor Darul Takzim",
    Tel: "06- 986 9244",
    Fax: "06- 986 0999",
    Email: "ehwwsb@hotmail.com",
    Area: "MUAR",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 664,
    Name: "Sin Heng Auto Works Sdn Bhd",
    Address:
      "No.9, Jalan Permatang 17\nTaman Desa Jaya\n81100\nJohor Bahru\nJohor Darul Takzim",
    Tel: "07- 356 0010",
    Fax: "07- 356 0012",
    Email: "sinheng_workshop@hotmail.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 665,
    Name: "Soon Lee Welder & Spraying Works Sdn Bhd",
    Address:
      "No 1, Jalan Teknologi 1\nKawasan Perindustrian Mengkibol\n86000\nKluang\nJohor Darul Takzim",
    Tel: "07- 772 6832",
    Fax: "07- 772 7841",
    Email: "soonleewelder@yahoo.com",
    Area: "KLUANG",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 666,
    Name: "Yong Hup Soon Motorworks Sdn Bhd",
    Address:
      "No.1, Jalan Budi 4\nTaman Perindustrian Wawasan 2020\n83000\nBatu Pahat\nJohor Darul Takzim",
    Tel: "07- 428 8727\n07- 428 8728",
    Fax: "07- 4288726",
    Email: "yhs_claim@hotmail.my",
    Area: "BATU PAHAT",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 667,
    Name: "Ah Kum Motor Workshop Sdn. Bhd.",
    Address:
      "No 10, 12 & 32, Jalan Mutiara Emas 7/4\nTaman Mount Austin\n81100 Johor Bahru\nJohor",
    Tel: "019- 754 7988\n019- 777 8817",
    Fax: "07- 354 5670",
    Email: "ahkummotor@hotmail.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 668,
    Name: "GI Hoe Motor Works Sdn Bhd",
    Address: "Lot 8096, Batu 34 ½\nJalan Johor\n82000 Pontian\nJohor",
    Tel: "012-713 0458 / 016-780 9530",
    Fax: "07-687 3466",
    Email: "gihoe13@gmail.com",
    Area: "PONTIAN",
    Status: 0,
    State: "Johor",
  },
  {
    "Unique ID": 669,
    Name: "Heen Fatt Motor & Welding Works Sdn Bhd",
    Address:
      "PLO 132, No. 138, Kawasan Perindustrian\nJalan Genuang\n85000 Segamat\nJohor",
    Tel: "07-943 1767",
    Fax: "07-943 1918",
    Email: "hfm138@gmail.com",
    Area: "SEGAMAT",
    Status: 0,
    State: "Johor",
  },
  {
    "Unique ID": 670,
    Name: "Kluang Welding Sdn Bhd",
    Address: "17 Jalan Bangau,\nHappy Valley\n86000 Kluang\nJohor",
    Tel: "012- 738 9901\n07- 772 3106",
    Fax: "07- 771 3614",
    Email: "kluangwelding@gmail.com",
    Area: "KLUANG",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 671,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address:
      "No. 32, Jalan Seroja 37,\nTaman Johor Jaya\n81100 Johor Bahru\nJohor",
    Tel: "07- 355 7952\n07- 351 8890",
    Fax: "07- 355 7253",
    Email: "nanmarnms@gmail.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 672,
    Name: "Segamat Federal Motor (1979) Sdn Bhd",
    Address:
      "PLO 75 & 76, Segamat Industrial Area\nBatu 3 1/2, Jalan Genuang\n85000 Segamat\nJohor",
    Tel: null,
    Fax: "07-943 1019",
    Email: "vas@segamatfederal.com.my",
    Area: "SEGAMAT",
    Status: 0,
    State: "Johor",
  },
  {
    "Unique ID": 673,
    Name: "Sin Lai Heng Sdn Bhd",
    Address: "MBP 140.Lot 1712\nJalan Temenggong Ahmad\n84010 Muar\nJohor",
    Tel: "06- 981 2775\n06- 981 3380",
    Fax: "06- 981 3379",
    Email: "slhwsoh@gmail.com",
    Area: "MUAR",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 674,
    Name: "Bengkel Mengimpal Kereta KK Sdn Bhd",
    Address:
      "No.16, Jalan Kemajuan 3\nTaman Perindustrian Kota Tinggi\n81900 Kota Tinggi\nJohor Darul Takzim",
    Tel: "07- 883 4123",
    Fax: "07- 882 1212",
    Email: "kkmotor78@hotmail.com",
    Area: "KOTA TINGGI",
    Status: 0,
    State: "Johor",
  },
  {
    "Unique ID": 675,
    Name: "Chai Motor Workshop Sdn Bhd",
    Address:
      "No.3 & 5, Jalan Bertam 8\nTaman Daya\n81100 Johor Bahru\nJohor Darul Takzim",
    Tel: "07- 355 6862\n07- 355 5808\n016- 779 0612",
    Fax: "07- 354 7335",
    Email: "chaimotorwks@yahoo.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 676,
    Name: "Chew Brothers Workshop Sdn Bhd",
    Address:
      "Lot 1203, Jalan Muar\nBatu 16, P.O. Box 70\n84900 Tangkak\nJohor Darul Takzim",
    Tel: "06- 978 2020",
    Fax: "06- 978 2202",
    Email: "cbwsb20@gmail.com",
    Area: "TANGKAK",
    Status: 0,
    State: "Johor",
  },
  {
    "Unique ID": 677,
    Name: "G & L Auto Service Sdn Bhd",
    Address:
      "PTD 6446 , Batu 34\nJalan Johor\n82000 Pontian\nJohor Darul Takzim",
    Tel: "07- 686 4818",
    Fax: "07- 687 3818",
    Email: "glauto06@gmail.com",
    Area: "PONTIAN",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 678,
    Name: "Heng Heng Workshop Sdn Bhd",
    Address:
      "Lot 3735, Jalan Sialang\nKampung Tengah Sialang\n84900 Tangkak\nJohor Darul Takzim",
    Tel: "06- 978 3567\n06- 978 8567",
    Fax: "06- 978 4567",
    Email: "hhtgk2014@gmail.com",
    Area: "TANGKAK",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 679,
    Name: "Heng SLW Motor Sdn Bhd",
    Address:
      "Lot 341 No4&5 , Batu 1 1/4\nJalan Mawai\n81900 Kota Tinggi\nJohor Darul Takzim",
    Tel: "07- 883 3046",
    Fax: "07- 883 6046",
    Email: "hengslw88@gmail.com",
    Area: "KOTA TINGGI",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 680,
    Name: "Hin Yap Motor Services Sdn Bhd",
    Address:
      "No.14,16,18 Jalan Satria 17\nTaman J.B. Perdana Industrial Park\n81300 Skudai\nJohor Darul Takzim",
    Tel: "07- 5121199",
    Fax: "07- 512 1915",
    Email: "hinyap_8888@yahoo.com",
    Area: "SKUDAI",
    Status: 0,
    State: "Johor",
  },
  {
    "Unique ID": 681,
    Name: "Hok Auto Services (JB) Sdn Bhd",
    Address:
      "8, Jalan Riang Ria,\nTaman Mulia Tampoi\n81200 Johor Bahru\nJohor Darul Takzim",
    Tel: "07 – 335 9093",
    Fax: "07 – 335 9115",
    Email: "hockas@gmail.com",
    Area: "JOHOR BAHRU",
    Status: 0,
    State: "Johor",
  },
  {
    "Unique ID": 682,
    Name: "Jin Fatt Workshop Sdn Bhd",
    Address:
      "PTD 45971, Jalan Suasa 1,\nTaman Perindustrian Kulai,\n81000 Kulai\nJohor Darul Takzim",
    Tel: "07- 662 6199\n07- 662 1826",
    Fax: "07- 662 3199",
    Email: "jinfatt@yahoo.com.my",
    Area: "KULAI",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 683,
    Name: "Kan Aik Automobile Sdn Bhd",
    Address: "No 119, Batu 1 1/2\nTanjung Agas\n84000 Muar\nJohor Darul Takzim",
    Tel: "06- 952 4859",
    Fax: "06- 952 4859",
    Email: "kanaikauto@gmail.com",
    Area: "MUAR",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 684,
    Name: "LB Automobile Sdn Bhd",
    Address:
      "PTD 3995, Kampung Sungai Karas\n 85300 Labis\n Johor Darul Takzim",
    Tel: "07- 925 6811\n019- 755 5368",
    Fax: "07- 925 6811",
    Email: "lbautomobilesb@gmail.com",
    Area: "LABIS",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 685,
    Name: "Lian Heng Motor Sdn Bhd",
    Address:
      "Lot 40, Jalan Air Hitam, Air Bemban\n81020 Kulai\nJohor Darul Takzim",
    Tel: "07- 656 5888",
    Fax: "07- 656 1786",
    Email: "cchuanhu@yahoo.com\nlianhengmotor@yahoo.com",
    Area: "KULAI",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 686,
    Name: "Mersing Vehicle Services Sdn Bhd",
    Address:
      "PLO 16,Kawasan Industri Mersing,Jalan\nJemaluang,\n86800 Mersing\nJohor Darul Takzim",
    Tel: "07- 799 1710",
    Fax: "07- 799 7710",
    Email: "mersingvehicle@gmail.com",
    Area: "MERSING",
    Status: 0,
    State: "Johor",
  },
  {
    "Unique ID": 687,
    Name: "Pintar Workshop Sdn Bhd",
    Address:
      "Lot 4611, Jalan Bistari 1, Bindu, Tongkang\nPechah\n83010 Batu Pahat\nJohor Darul Takzim",
    Tel: "07-415 3633 / 415 3632",
    Fax: "07-415 2833",
    Email: "pintarworkshop@yahoo.com",
    Area: "BATU PAHAT",
    Status: 0,
    State: "Johor",
  },
  {
    "Unique ID": 688,
    Name: "Seng Chong Welding & Spraying Sdn Bhd",
    Address:
      "No G-1, G2 & G5\nJalan Mersing, Jemaluang\n86810 Mersing\nJohor Darul Takzim",
    Tel: "07- 792 1520",
    Fax: "07- 792 1666",
    Email: "schongwelding@gmail.com",
    Area: "MERSING",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 689,
    Name: "Shoon Fat Car Repairing Workshop Sdn Bhd",
    Address:
      "Lot 2265, Jalan River Estate,\nJMYP, Jalan Muar\n83700 Yong Peng\nJohor Darul Takzim",
    Tel: "07- 468 1666\n07- 468 1000",
    Fax: "07- 467 9368",
    Email: "shoonfat6641@hotmail.com",
    Area: "YONG PENG",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 690,
    Name: "Sing Yap Auto Workshop Sdn Bhd",
    Address:
      "Lot 2354-5, Jalan Kempas Lama\nOpposite Taman Anggerik\n81300 Skudai\nJohor Darul Takzim",
    Tel: "07- 772 6832",
    Fax: "07- 772 7841",
    Email: "singyapauto@hotmail.com",
    Area: "SKUDAI",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 691,
    Name: "TYK Motor Sdn Bhd",
    Address:
      "No.6, Jalan Mutiara Emas 6/2\nTaman Mount Austin\n81100 Johor Bahru\nJohor Darul Takzim",
    Tel: "07- 351 2635",
    Fax: "07- 351 2636",
    Email: "tykmotor@yahoo.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 692,
    Name: "Wan Sheng Motor Workshop Sdn Bhd",
    Address:
      "No 3 Jalan Shahbandar 8\nTaman Ungku Tun Aminah\n81300 Skudai\nJohor Darul Takzim",
    Tel: "07- 557 8978",
    Fax: "07- 557 9978",
    Email: "seng_motor@yahoo.com",
    Area: "SKUDAI",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 693,
    Name: "Weng Sun Car Welding & Agency Sdn Bhd",
    Address:
      "4, Jalan Jening\nTaman Johor\n81200 Johor Bahru\nJohor Darul Takzim",
    Tel: "07- 234 0959\n07- 235 0959",
    Fax: "07- 235 3959",
    Email: "wengsuncar@hotmail.com\nwengsun@wengsun.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 694,
    Name: "Wong Kah Kwee Workshop Sdn Bhd",
    Address:
      "No.7 Jalan Masai Lama,\nKawasan Perindustrian Kota\nPutri 1, \n81750 Masai, Johor.",
    Tel: "07- 386 0000\n07- 386 3838\n07- 386 3399",
    Fax: "07- 382 1712",
    Email: "wkkww@pd.jaring.my\nwkkwsb@yahoo.com.my",
    Area: "MASAI",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 695,
    Name: "Yong Heng Autocar Services (M) Sdn Bhd",
    Address:
      "MLO 1272, Jalan Buloh Kasap,\nKg. Batu Lima, Buloh Kasap,\n85010 Segamat\nJohor Darul Takzim",
    Tel: "019- 718 3999\n07- 944 3898",
    Fax: "07- 944 3898",
    Email: "poheng33@gmail.com",
    Area: "SEGAMAT",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 696,
    Name: "Yong Hup Soon Motorworks Sdn Bhd",
    Address:
      "No.1, Jalan Budi 4\nTaman Perindustrian Wawasan 2020\n83000 Batu Pahat\nJohor Darul Takzim",
    Tel: "07- 428 8727 /428 8728",
    Fax: "07- 4288726",
    Email: "yhs_claim@hotmail.my",
    Area: "BATU PAHAT",
    Status: 0,
    State: "Johor",
  },
  {
    "Unique ID": 697,
    Name: "Yoon Sang Welding Workshop Sdn Bhd",
    Address:
      "No 26 Jalan Sri Plentong 2\nTaman Perindustrian, Sri Plentong\n81750 Masai\nJohor Darul Takzim",
    Tel: "07- 388 2284",
    Fax: "07- 388 6535",
    Email: "ysangw@hotmail.com",
    Area: "MASAI",
    Status: 0,
    State: "Johor",
  },
  {
    "Unique ID": 950,
    Name: "Yon Huat Motor Works Sdn Bhd",
    Address:
      "Lot 1770, 3683 & 3684,\nJalan Bindu,\n80313 Tongkang Pechah,\nBatu Pahat, Johor.",
    Tel: "07- 415 2888",
    Fax: "07- 415 6777",
    Email: "claims@yonhuat.com",
    Area: "Batu Pahat",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1087,
    Name: "Prestige Wheels Sdn Bhd",
    Address:
      "Lot 3323, Jalan Parit Bilal\n83000 Batu Pahat\nJohor Darul Takzim\n",
    Tel: "07- 4315768\n07- 4385768\n07- 4327890\n",
    Fax: null,
    Email: "pw.bpaint@gmail.com",
    Area: "BATU PAHAT",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1377,
    Name: "Woon Soon Workshop Sdn Bhd",
    Address:
      "No. 61, 63, 65 & 86 Jalan Bertam 5\nTaman Daya\n81100 Johor Bahru\nJohor Darul Takzim",
    Tel: "07- 355 7876",
    Fax: null,
    Email: "wsoonworkshop@gmail.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 621,
    Name: "Juta Oven Spray Painting Sdn Bhd",
    Address:
      "No.91 Jalan Timur 6\nKawasan Perusahaan Mergong Barrage\n05050\nAlor Setar\nKedah Darul Aman",
    Tel: "04- 733 5715",
    Fax: "04- 733 9668",
    Email: "jutaoven@hotmail.com",
    Area: "ALOR SETAR",
    Status: 1,
    State: "Kedah",
  },
  {
    "Unique ID": 622,
    Name: "Indah Utara Auto Service Centre Sdn Bhd",
    Address: "No. 80B, KM 10\nJalan Datuk Kumbar\n6500 Alor Setar\nKedah",
    Tel: "016 - 420 6442\n012- 597 1111\n",
    Fax: null,
    Email: "infobnp_as@indahutara.com.my ",
    Area: "ALOR SETAR",
    Status: 1,
    State: "Kedah",
  },
  {
    "Unique ID": 623,
    Name: "LLS Motor Workshop Sdn Bhd",
    Address:
      "No A-16, Jalan Fairuz 9/2,\nTaman Perusahaan Ringan Bakar Arang,\n08000 Sungai Petani\nKedah Darul Aman",
    Tel: "04- 4310159\n04- 4310891",
    Fax: "04- 4310285",
    Email: "llsmwsb@gmail.com\nbell.ng@llsworkshop.com.my",
    Area: "SUNGAI PETANI",
    Status: 1,
    State: "Kedah",
  },
  {
    "Unique ID": 624,
    Name: "Mun LY Automobile Service Sdn Bhd",
    Address:
      "Lot 1391. Jalan Watt Siam\nKampung Raja\n08000 Sungai Petani\nKedah",
    Tel: "04-425 9809 / 019-474 6759",
    Fax: "04-425 2809",
    Email: "spmunly@gmail.com",
    Area: "SUNGAI PETANI",
    Status: 0,
    State: "Kedah",
  },
  {
    "Unique ID": 625,
    Name: "U-Lek Motor Sdn Bhd",
    Address: "30-B Kampong Sg. Menghulu Batu 2\n7000 Langkawi\nKedah",
    Tel: "04- 966 9193\n012- 494 1949",
    Fax: null,
    Email: "ulek_lgk@yahoo.com",
    Area: "LANGKAWI",
    Status: 1,
    State: "Kedah",
  },
  {
    "Unique ID": 626,
    Name: "AS Lean Huat Auto Repair & Trading Sdn Bhd",
    Address:
      "1562, Batu 4 ¼, Jalan Simpang Empat\n05400 Alor Setar\nKedah Darul Aman",
    Tel: "04- 764 1180",
    Fax: "04- 764 3010",
    Email: "asleanhuat@gmail.com",
    Area: "ALOR SETAR",
    Status: 0,
    State: "Kedah",
  },
  {
    "Unique ID": 627,
    Name: "Autolim Langkawi Service & Parts Sdn Bhd",
    Address:
      "Lot 952, Kg. Bukit Tekoh\nMukim Kuah\n07000 Langkawi\nKedah Darul Aman",
    Tel: "04- 966 8243",
    Fax: "04- 966 8245",
    Email: "autolim3833@yahoo.com",
    Area: "LANGKAWI",
    Status: 0,
    State: "Kedah",
  },
  {
    "Unique ID": 628,
    Name: "Bengkel Weng Keong Sdn Bhd",
    Address: "Lot 117, Jalan Kelang Lama\nLunas\n09000 Kulim\nKedah Darul Aman",
    Tel: "04- 491 2218",
    Fax: "04- 495 9360",
    Email: "wengkeong999@yahoo.com",
    Area: "KULIM",
    Status: 1,
    State: "Kedah",
  },
  {
    "Unique ID": 629,
    Name: "Jerai Workshop Service (M) Sdn Bhd",
    Address:
      "Lot 3 PT 9485,Jalan Pejabat Lebuhraya\n08300 Gurun\nKedah Darul Aman",
    Tel: "04- 468 1443\n04- 468 2466",
    Fax: "04- 468 1448",
    Email: "jeraiworkshop@gmail.com\njwsmsb@yahoo.com",
    Area: "GURUN",
    Status: 1,
    State: "Kedah",
  },
  {
    "Unique ID": 630,
    Name: "Meng Kwang Car Repairs Sdn Bhd",
    Address: "No.183-A, Batu Satu\n08100 Bedong\nKedah Darul Aman",
    Tel: "04- 458 7137",
    Fax: "04- 458 7112",
    Email: "mengkwangworkshop1@gmail.com;mengkwangworkshop2@gmail.com",
    Area: "BEDONG",
    Status: 1,
    State: "Kedah",
  },
  {
    "Unique ID": 631,
    Name: "Sam Soon Automobile Services Sdn Bhd",
    Address: "1473 Batu 1 ¼\nJalan Langgar\n05460 Alor Setar\nKedah Darul Aman",
    Tel: "04-733 5648, 735 1343",
    Fax: "04- 734 9309",
    Email: "samsoonauto@gmail.com",
    Area: "ALOR SETAR",
    Status: 0,
    State: "Kedah",
  },
  {
    "Unique ID": 698,
    Name: "Dit Soon Heng Auto Services Sdn Bhd",
    Address:
      "PT 79 & 80, Kawasan Industri Gua Musang,\n18300 Gua Musang\nKelantan Darul Naim",
    Tel: "09- 912 6333",
    Fax: "09- 912 0333",
    Email: "ditsoon@yahoo.com",
    Area: "GUA MUSANG",
    Status: 1,
    State: "Kelantan",
  },
  {
    "Unique ID": 699,
    Name: "K & T Engineering & Trading Sdn Bhd",
    Address:
      "Lot PT 1426, Nlok H, Kaw. Perindustrian\nPengkalan Chepa II\nMukim Kemimin, Daerah Panji, Seksyen 14\n16100 Kota Bharu\nKelantan Darul Naim",
    Tel: "09-773 2522 / 09-771 3060",
    Fax: "09-773 8403",
    Email: "hinokb@gmail.com",
    Area: "KOTA BHARU",
    Status: 0,
    State: "Kelantan",
  },
  {
    "Unique ID": 700,
    Name: "K. B. Hup Soon Motors Sdn Bhd",
    Address:
      "Lot 44, Kawasan MIEL Lundang\nJalan Sultan Yahya Petra\n15200\nKota Bharu\nKelantan Darul Naim",
    Tel: "09- 744 1607",
    Fax: "09- 743 2848",
    Email: "kbhupsoon@gmail.com",
    Area: "KOTA BHARU",
    Status: 0,
    State: "Kelantan",
  },
  {
    "Unique ID": 701,
    Name: "Sim Motor Workshop (KB) Sdn Bhd",
    Address:
      "Lot 1683, Mukim Tapang\nPanji, Kampung Dusun Raja\n16100\nKota Bharu\nKelantan Darul Naim",
    Tel: "09- 773 0199",
    Fax: "09- 774 4199",
    Email: "loo68@live.com",
    Area: "KOTA BHARU",
    Status: 1,
    State: "Kelantan",
  },
  {
    "Unique ID": 702,
    Name: "Wee & Lee Motor Works Sdn Bhd",
    Address:
      "Lot 1209, Jalan Pasir Puteh\nKubang Kerian\n16150 Kota Bharu\nKelantan Darul Naim",
    Tel: "09- 765 3337",
    Fax: "09- 765 2789",
    Email: "wee_lee_workshop@hotmail.com",
    Area: "KOTA BHARU",
    Status: 1,
    State: "Kelantan",
  },
  {
    "Unique ID": 1086,
    Name: "PNP Auto Sdn Bhd",
    Address: "Lot.914, Kampung Dalam,\n16200 Tumpat,\nKelantan",
    Tel: "019- 979 7969",
    Fax: null,
    Email: "pnpautosdnbhd@gmail.com",
    Area: "Tumpat",
    Status: 1,
    State: "Kelantan",
  },
  {
    "Unique ID": 751,
    Name: "Bengkel Kereta Reliance Sdn Bhd",
    Address:
      "No. 29, Lot 337, Seksyen 92\nJalan 2, Chan Sow Lin\n55200 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 9221 8488\n03- 922 16488\n03- 9221 5488\n03- 9221 6162",
    Fax: "03- 9221 2478",
    Email: "btsoo@pc.jaring.my\nbtsoo@relianceautokl.com",
    Area: "KUALA LUMPUR",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 752,
    Name: "WTF Auto Services Sdn Bhd",
    Address:
      "No.23A, Jalan Empat\nOff Jalan Chan Sow Lin\n55200 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 9221 3997\n03- 9221 0997\n03- 9221 0998",
    Fax: "03- 9221 7996",
    Email: "tkwong@wtfauto.com.my\ninfo@wtfauto.com.my",
    Area: "KUALA LUMPUR",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 753,
    Name: "Ah Wan Auto Repair Sdn Bhd",
    Address:
      "No. 24, Jalan 6\nTaman Perindustrian Ehsan Jaya, Kepong\n52100 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "06-6273 1000 / 012-364 4122",
    Fax: "03-6273 5437",
    Email: "ahwanauto@hotmail.com",
    Area: "KEPONG",
    Status: 0,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 755,
    Name: "Bengkel Baru Seng Soon Sdn Bhd",
    Address:
      "13, 14, 16 & 17, Jalan 6\nTaman Industrial Ehsan Jaya\nTaman Ehsan\n52100 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 6275 4518",
    Fax: "03- 6275 3976",
    Email: "bbsengsoon@sengsoon.com; bbsengsoon@hotmail.com",
    Area: "KEPONG",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 756,
    Name: "Bengkel Chin Ho Sdn Bhd",
    Address:
      "Lot. 3687, Batu 4 1/2 Jalan Segambut\n51200 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 6257 1905\n03- 6250 1300\n03- 6252 3363",
    Fax: "03- 6257 8632",
    Email: "bch3363@yahoo.com",
    Area: "SEGAMBUT",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 757,
    Name: "BSM Motor Works Sdn Bhd",
    Address:
      "No. 33, Jalan 7/23A, Taman Danau Kota\nOff Jalan Genting Klang, Setapak\n53300 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 4142 8122",
    Fax: "03- 4142 7121",
    Email: "bsmmotorworks@gmail.com",
    Area: "SETAPAK",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 758,
    Name: "CB Motor Ehsan Jaya Sdn Bhd",
    Address:
      "No 217 Jalan 1\nTaman Industry Ehsan Jaya\n52100 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 6277 1050",
    Fax: "03- 6277 1060",
    Email: "cbmotor012@gmail.com\ncbmotor012@yahoo.com",
    Area: "KEPONG",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 759,
    Name: "Fasline Auto Engineering Sdn Bhd",
    Address:
      "Yee Seng Godown 12\nLot 5746 4 1/2 Miles Old Klang Road\n58000 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03-7983 0493",
    Fax: "03-7983 4973",
    Email: "fasline@gmail.com",
    Area: "KUALA LUMPUR",
    Status: 0,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 760,
    Name: "HM Hong Motors Sdn Bhd",
    Address:
      "No 26 & 28 Jalan Tago 7\nTaman Perindustrian Tago\nBandar Sri Damansara\n52200 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 6276 3998",
    Fax: "03- 6276 3822",
    Email: "hongmotor@yahoo.com.my",
    Area: "KUALA LUMPUR",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 761,
    Name: "Hoh Seng Car Works Sdn Bhd",
    Address:
      "Lot 402, 5 3/4 Miles Old Klang Road\n58000 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 7781 7873",
    Fax: "03- 7784 7617",
    Email: "hohseng3@gmail.com",
    Area: "KUALA LUMPUR",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 762,
    Name: "Hua Hong Auto Sdn Bhd",
    Address:
      "No. 3 & 5, Jalan Sibu 17,\nTaman Wahyu\n68100 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 6253 4252",
    Fax: "03- 6251 4252",
    Email: "huahongauto@yahoo.com",
    Area: "KUALA LUMPUR",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 763,
    Name: "Hup Yau Motor Works Sdn Bhd",
    Address:
      "Lot 3A, Jalan Wangsa Utama\nTaman Wangsa Permai\n52200\nKuala Lumpur\nWilayah Persekutuan",
    Tel: "03-6277 8088/ 03-6277 8288",
    Fax: "03-6277 2958",
    Email: "mandy_kong_82@hotmail.com\nhupyau66@gmail.com",
    Area: "KUALA LUMPUR",
    Status: 0,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 764,
    Name: "IMS Motorsports (KL) Sdn Bhd",
    Address:
      "No 21, Jalan Empat\nOff Jalan Chan Sow Lin\n55200 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 9222 2206",
    Fax: "03- 9222 2322",
    Email: "ims_csl@yahoo.com\ninquiry@imsgroups.com.my",
    Area: "KUALA LUMPUR",
    Status: 0,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 765,
    Name: "Joo Auto Works Sdn Bhd",
    Address:
      "Lot 1217, Jalan Kampung Segambut\nTengah\nSegambut\n51200 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 6257 0889\n03- 6257 7748",
    Fax: "03- 6258 2355",
    Email: "jooauto1217@gmail.com",
    Area: "SEGAMBUT",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 766,
    Name: "Kee Cheong Auto Sdn Bhd",
    Address:
      "Lot 9, Jalan Perusahaan Kiri,\nKawasan Perusahaan Ringan, Setapak\n53200 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03-4022 2428 / 4022 2899",
    Fax: "03-4022 4425",
    Email: "kcasb9@gmail.com\ntwl8938@yahoo.com",
    Area: "SETAPAK",
    Status: 0,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 768,
    Name: "Kiam Yen Motors Sdn Bhd",
    Address: "No 1, Jalan Usaha Jaya,\nTaman Usaha Jaya,\n52100 Kuala Lumpur.",
    Tel: "03- 6277 5255\n017- 5003935",
    Fax: "03- 6277 6252",
    Email: "kyenmsb@gmail.com",
    Area: "KUALA LUMPUR",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 769,
    Name: "Kum Onn Workshop Sdn Bhd",
    Address:
      "No 43, Jalan 6/118C\nDesa Tun Razak\n56000 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 9173 8888",
    Fax: "03- 9173 7787",
    Email: "kumonn18@gmail.com",
    Area: "KUALA LUMPUR",
    Status: 0,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 770,
    Name: "L & P Workshop (Kepong) Sdn Bhd",
    Address:
      "Lot 32713, Off Jalan Kepong\nBatu 6 1/2\n52000 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 6250 0211(hunting line)",
    Fax: "03- 6259 1669",
    Email: "lpwksb@yahoo.com.my",
    Area: "KUALA LUMPUR",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 771,
    Name: "Ong Soon Hoe Motor Sdn Bhd",
    Address:
      "41, Persiaran Segambut Tengah\n51200 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 6258 2572",
    Fax: "03- 6257 3812",
    Email: "ongsoonhoemotor@gmail.com",
    Area: "SEGAMBUT",
    Status: 0,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 772,
    Name: "Sing Motor Works Sdn Bhd",
    Address:
      "No. 8C, Lot 1031,\nBt. 7, Jalan Puchong\n58200\nKuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 8075 3323\n03- 8076 1205\n03- 8076 1281",
    Fax: "03- 8076 1227",
    Email: "singmotor@hotmail.com",
    Area: "KUALA LUMPUR",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 774,
    Name: "Syarikat Bengkel Soan Huat Sdn Bhd",
    Address:
      "No.26, Persiaran Segambut Tengah\n51200 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 6257 0559,6257 7150",
    Fax: "03- 6251 8835",
    Email: "soanhuat@yahoo.com\nsoanhuat@gmail.com",
    Area: "SEGAMBUT",
    Status: 0,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 775,
    Name: "Tet Lee Workshop Sdn Bhd",
    Address:
      "No. 34 & 36, Jalan Sibu 17,\nTaman Wahyu, Batu 6, Jalan Ipoh\n68100\nWilayah Persekutuan.",
    Tel: "03- 6242 7222\n03-6243 4111",
    Fax: "03- 6257 4200",
    Email: "tetlee63@gmail.com",
    Area: "KUALA LUMPUR",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 776,
    Name: "Weng Hup Motor Works Sdn Bhd",
    Address:
      "1, Jalan 10/108C\nTaman Sungei Besi\n57100 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 7981 5807",
    Fax: "03- 7982 3964",
    Email: "admin@wenghup.com",
    Area: "KUALA LUMPUR",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 777,
    Name: "Xin Workshop Sdn Bhd",
    Address:
      "31, Jalan 11/32B\nTSI Business Industrial Park\n52100 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03-6257 1238 / 019 -225 2731",
    Fax: "03-6250 0597",
    Email: "xin.workshop88@gmail.com",
    Area: "KUALA LUMPUR",
    Status: 0,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1379,
    Name: "Ming Soon Car Cares Sdn Bhd",
    Address:
      "No.1, Jalan Bukit Permai Utama\nTaman Industri Bukit Permai\n56100 Kuala Lumpur",
    Tel: "03- 8090 9129",
    Fax: null,
    Email: "mingsoonccsb@gmail.com",
    Area: "KUALA LUMPUR",
    Status: 0,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 655,
    Name: "Uni K.S Mudguard Sdn Bhd",
    Address: "No.54& 56, Jalan Berkat 8\nTaman Malim Jaya\n75250\nMelaka",
    Tel: "06- 335 3091\n06- 335 0092",
    Fax: "06- 3353091",
    Email: "uniksmudguard@gmail.com",
    Area: "MELAKA",
    Status: 1,
    State: "Malacca",
  },
  {
    "Unique ID": 656,
    Name: "C H Ee Auto Workshop Sdn Bhd",
    Address: "No.2 Jalan Suria 6,\nTaman Malim Jaya\n75250 Melaka\nMelaka",
    Tel: "06-336 3636 / 019-659 1496",
    Fax: "06-335 0913",
    Email: "cheeauto@yahoo.com",
    Area: "MELAKA",
    Status: 0,
    State: "Malacca",
  },
  {
    "Unique ID": 657,
    Name: "Sing Kwung Auto Sdn Bhd",
    Address:
      "Lot 4432, Jalan TTC 6\nKawasan Perindustrian Cheng\n75250 Melaka\nMelaka",
    Tel: "06- 335 8255\n06- 335 5104",
    Fax: "06- 334 0315",
    Email: "ngsinyean@skasb.com.my",
    Area: "MELAKA",
    Status: 1,
    State: "Malacca",
  },
  {
    "Unique ID": 658,
    Name: "Soon-Ly Auto Sdn Bhd",
    Address: "No. 39, Jalan Suria 1\nTaman Malim Jaya\n75250 Melaka\nMelaka",
    Tel: "06-335 0490 / 012-618 0007",
    Fax: "06-335 3178",
    Email: "soon_lyauto@yahoo.com.my",
    Area: "MELAKA",
    Status: 0,
    State: "Malacca",
  },
  {
    "Unique ID": 659,
    Name: "M.K Lim Motor Workshop Sdn Bhd",
    Address:
      "JA2723. Kawasan Industrial Ringan\nTaman Maju\n77000 Jasin\nMelaka",
    Tel: "06- 529 1391",
    Fax: "06- 529 5323",
    Email: "mklimmotor@yahoo.com",
    Area: "JASIN",
    Status: 1,
    State: "Malacca",
  },
  {
    "Unique ID": 660,
    Name: "SMAG Motor Sdn Bhd",
    Address: "No 2226, Taman IKS\nJalan Paya Datok\n78000 Alor Gajah\nMelaka",
    Tel: "06- 556 1454",
    Fax: "06- 556 0878",
    Email: "smagmlk@gmail.com",
    Area: "ALOR GAJAH",
    Status: 1,
    State: "Malacca",
  },
  {
    "Unique ID": 661,
    Name: "Soon Tai Towing & Service Centre Sdn Bhd",
    Address: "Lot 23, M2 Iks Merlimau\nJalan Muar\n77300 Melimau\nMelaka",
    Tel: "012- 688 6100\n014- 660 0360",
    Fax: "06- 261 8700",
    Email: "stt_71@yahoo.com.my\nsoontaitowing@ymail.com",
    Area: "MERLIMAU",
    Status: 1,
    State: "Malacca",
  },
  {
    "Unique ID": 778,
    Name: "Ar Shieng Sdn Bhd",
    Address:
      "T-205,Senawang Light\nJalan Tampin\n70450\nSeremban\nNegeri Sembilan Darul Khusus",
    Tel: "06- 6775984\n06- 6775985\n06- 6775986",
    Fax: "06- 678 3966",
    Email: "arshieng@yahoo.com",
    Area: "SENAWANG",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 779,
    Name: "Suen Fatt Workshop Sdn Bhd",
    Address:
      "Lot 30927, Bt 9, Jalan Besar\n71700\nMantin\nNegeri Sembilan Darul Khusus",
    Tel: "06- 758 6333\n06- 758 7333\n06- 758 1364\n06- 7581563",
    Fax: "06- 758 2821\n06- 758 3563",
    Email: "info@suenfatt.com.my",
    Area: "MANTIN",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 780,
    Name: "Chee Kong Motor Sdn Bhd",
    Address:
      "PT 2100, 2102, 2102, 2103 & 2104, S.H. (D) 71923\nSri Senawang Light Industri Centre\n70450 Seremban\nNegeri Sembilan Darul Khusus",
    Tel: "06-  677 1889\n06-  677 3889",
    Fax: "06-  677 1350",
    Email: "choywan@cheekongmotor.com.my",
    Area: "SENAWANG",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 781,
    Name: "Motor Jempol Sdn Bhd",
    Address: "1 ½ Miles, Jalan Kuala Pilah\n72100 Bahau\nNegeri Sembilan",
    Tel: "06- 454 1428",
    Fax: "06- 454 5178",
    Email: "mjempol@hotmail.com",
    Area: "BAHAU",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 782,
    Name: "Thian Wah Motor Sdn Bhd",
    Address:
      "No 54 & 55, Jln Industri 3\nTaman Perindustrian Lukut Indah\n71010 Port Dickson\nNegeri Sembilan",
    Tel: "06- 651 1689",
    Fax: null,
    Email: "thianwah1689@gmail.com",
    Area: "PORT DICKSON",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 783,
    Name: "Bengkel Pertama (M) Sdn Bhd",
    Address:
      "PT 2151, Sri Senawang Light Industrial\nJalan Tampin Mukin Rantau\n70450 Seremban \nNegeri Sembilan Darul Khusus",
    Tel: "06- 677 3928",
    Fax: "06- 677 4928",
    Email: "bpertama2151@gmail.com",
    Area: "SEREMBAN",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 784,
    Name: "Chen Li Auto Builder Sdn Bhd",
    Address:
      "PT 8612, Galla Industrial Park\nBatu 4, Labu\n70200 Seremban\nNegeri Sembilan Darul Khusus",
    Tel: "06- 765 3703, 765 3704",
    Fax: "06- 765 3708",
    Email: "chenlins@hotmail.my",
    Area: "SEREMBAN",
    Status: 0,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 785,
    Name: "Fung Chan Motor Sdn Bhd",
    Address:
      "59 & 61 Jalan Lombong Emas 5, Seremban\nLight Ind. Park\nJalan Tun Dr Ismail\n70200 Seremban\nNegeri Sembilan Darul Khusus",
    Tel: "06- 767 7797",
    Fax: "06- 767 7846",
    Email: "fungchanmotor@gmail.com",
    Area: "SEREMBAN",
    Status: 0,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 786,
    Name: "Lai Hon Ming Motors (M) Sdn Bhd",
    Address:
      "PT 3319, Jalan Permata 1/1\nArab Malaysian Industrial Park\n71800 Nilai\nNegeri Sembilan Darul Khusus",
    Tel: "06- 799 2299",
    Fax: "06- 799 6699",
    Email: "lhmmotors@gmail.com",
    Area: "NILAI",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 787,
    Name: "N.T.P. Automobile Sdn Bhd",
    Address:
      "SD 23 Senawang Light Ind\n4 1/2 Miles, Jalan Tampin\n70450 Seremban\nNegeri Sembilan Darul Khusus",
    Tel: "06- 679 8991\n06- 677 3660",
    Fax: "06- 679 8991",
    Email: "ntp.senawang@yahoo.com",
    Area: "SEREMBAN",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 788,
    Name: "New Wee Seng Motor Sdn Bhd",
    Address:
      "No 83 A, Lorong 3/2\nSenawang Industrial Estate\n70450\nSeremban\nNegeri Sembilan Darul Khusus",
    Tel: "06- 677 4001",
    Fax: "06- 677 8300",
    Email: "weesengmotor@yahoo.com",
    Area: "SENAWANG",
    Status: 0,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 789,
    Name: "Petri Seremban Automobil Sdn Bhd",
    Address:
      "No 2580, Taman Rasah Jaya\n70300 Seremban\nNegeri Sembilan Darul Khusus",
    Tel: "06- 631 5008\n06- 632 9188\n06- 633 3195",
    Fax: "06- 632 2028",
    Email: "sps@petrisbn.com.my",
    Area: "SEREMBAN",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 790,
    Name: "Rantau WY Auto Workshop Sdn Bhd",
    Address:
      "Lot 796, No. 174,\nKampung Ribu Rantau,\n71200 Rantau\nNegeri Sembilan Darul Khusus",
    Tel: "06- 694 6254\n012- 618 6004",
    Fax: "06- 694 6229",
    Email: "wyautos@yahoo.com",
    Area: "RANTAU",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 791,
    Name: "Seremban Assist Auto Sdn Bhd",
    Address:
      "No 3 Jalan Lombong Emas Sebelas\nSeremban Light Ind. Park\nOff Jalan Tun Dr Ismail\n70200 Seremban\nNegeri Sembilan Darul Khusus",
    Tel: "06- 764 2591",
    Fax: "06- 764 2592",
    Email: "jengmuns@yahoo.com",
    Area: "SEREMBAN",
    Status: 0,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 792,
    Name: "Soon Seng Automobile Sdn Bhd",
    Address:
      "Lot 229-231, Senawang Light Industrial\nJalan Tampin\n70450 Seremban\nNegeri Sembilan Darul Khusus",
    Tel: "06- 677 2959 (Seremban)\n06- 799 9425 (Nilai)",
    Fax: "06- 677 7835 (Seremban)\n06- 799 9373 (Nilai)",
    Email: "soonsengsban@gmail.com",
    Area: "SENAWANG",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 793,
    Name: "Syarikat Eng Hup Car Service Centre Sdn Bhd",
    Address:
      "No 62 A, Jalan Bahau, Gentam\n72000 Kuala Pilah\nNegeri Sembilan Darul Khusus",
    Tel: "06- 481 4589\n06- 481 3181",
    Fax: "06- 481 3010",
    Email: "enghupkp@hotmail.com\nenghupbh@hotmail.com",
    Area: "KUALA PILAH",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 794,
    Name: "Tampin Motor Sdn Bhd",
    Address:
      "No. 6000. PT. 1258. Industri Kecil Repah\nBatu 2 1/2, Jalan Gemas\n73000 Tampin\nNegeri Sembilan Darul Khusus",
    Tel: "06- 441 6699\n06- 441 9966\n06- 441 9977",
    Fax: "06- 441 4209",
    Email: "tampinmotor@yahoo.com\ntampinmotor@hotmail.com",
    Area: "TAMPIN",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 703,
    Name: "Hoi Keen Auto Spray Sdn Bhd",
    Address:
      "No.A551, Jalan Padang Lalang\n25050\nKuantan\nPahang Darul Makmur",
    Tel: "09- 516 1898\n09- 516 2471",
    Fax: "09- 516 5898",
    Email: "hoikeenauto@hotmail.com",
    Area: "KUANTAN",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 704,
    Name: "Swee Lee Workshop Sdn Bhd",
    Address:
      "No. 3, Jalan IM 3/7 LTAT Sektor 1,\nBandar Indera Mahkota\n25200\nKuantan\nPahang Darul Makmur",
    Tel: "09- 573 8088\n09- 572 1682\n09- 572 1688",
    Fax: "09- 573 9088",
    Email: "sweelee2005@gmail.com",
    Area: "KUANTAN",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 705,
    Name: "Chin Hua Auto Works Sdn Bhd",
    Address:
      "Lot 453, Jalan Kuantan-Pelabuhan\n(Kuantan Bypass)\nMukim Sungai Karang\n26100 Kuantan\nPahang",
    Tel: "09-560 4419 / 013-983 1623",
    Fax: "09-568 9612",
    Email: "chinhuaauto@gmail.com",
    Area: "KUANTAN",
    Status: 0,
    State: "Pahang",
  },
  {
    "Unique ID": 706,
    Name: "Leong Workshop (Kuantan) Sdn Bhd",
    Address: "D-545 , Jalan Padang Lallang\n25050 Kuantan\nPahang",
    Tel: "013- 923 1398\n013- 927 1398",
    Fax: "09- 558 1399",
    Email: "leongworkshop@yahoo.com",
    Area: "KUANTAN",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 707,
    Name: "Siong Fatt Mudguard Workshop Sdn Bhd",
    Address:
      "No.6 Jalan Industri 1\nTaman Perindustrian Temerloh\n28400 Mentakab\nPahang",
    Tel: "019- 986 2461\n09- 278 3928",
    Fax: "09- 277 0585",
    Email: "sfmwsb2020@gmail.com",
    Area: "MENTAKAB",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 708,
    Name: "Temerloh Majujaya Auto Services Sdn Bhd",
    Address:
      "No. 27-29, Jalan Industri 3/3\nTaman Perindustrian Temerluh\n28400 Mentakab\nPahang",
    Tel: "09- 277 5411\n019- 988 6222",
    Fax: "09- 278 3411",
    Email: "temerlohmajujaya@hotmail.com",
    Area: "MENTAKAB",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 709,
    Name: "Bera P.J Auto Services Sdn Bhd",
    Address:
      "No.160-166 Jalan Highway\nTaman Sri Triang\n28300 Triang\nPahang Darul Makmur",
    Tel: "09- 2551 222",
    Fax: "09-2551 222",
    Email: "tcysgh@yahoo.com",
    Area: "TRIANG",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 710,
    Name: "Hadhari Automobile Sdn Bhd",
    Address:
      "BK - 6 Kawasan Industri Mara\nBatu 5 1/2 Jalan Gambang\n25150 Kuantan\nPahang Darul Makmur",
    Tel: "09- 536 2349",
    Fax: "09- 536 7349",
    Email: "hadhariauto@gmail.com",
    Area: "KUANTAN",
    Status: 0,
    State: "Pahang",
  },
  {
    "Unique ID": 711,
    Name: "JYW Car Service Center Sdn Bhd",
    Address: "Batu 2 1/2, Jalan Lipis\n27600 Raub\nPahang Darul Makmur",
    Tel: "09- 355 9395",
    Fax: "09- 355 9400",
    Email: "jywcarservice@gmail.com",
    Area: "RAUB",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 712,
    Name: "Kam Sheng Auto Care Sdn Bhd",
    Address:
      "No 2 Jalan Industri Semambu 9/3\nIndustri Semambu\n25300 Kuantan\nPahang Darul Makmur",
    Tel: "09- 568 2866",
    Fax: "09- 568 2868",
    Email: "kamshengauto@gmail.com",
    Area: "KUANTAN",
    Status: 0,
    State: "Pahang",
  },
  {
    "Unique ID": 713,
    Name: "Kou Sing Workshop Sdn Bhd",
    Address:
      "Lot 4341 Batu 1 1/5 Jalan Tras\n28700 Bentong\nPahang Darul Makmur",
    Tel: "09- 223 2905",
    Fax: "09- 222 9433",
    Email: "lum_chee_kian@hotmail.com",
    Area: "BENTONG",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 714,
    Name: "Lipis Mudguard Sdn Bhd",
    Address:
      "Lot 78, Industri Ringan Tempoyang\n27200 Kuala Lipis\nPahang Darul Makmur",
    Tel: "09- 312 2866",
    Fax: "09- 312 2866",
    Email: "lipismud@streamyx.com\nlipismudguardlok@outlook.com",
    Area: "KUALA LIPIS",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 715,
    Name: "M & Y Auto Services Sdn Bhd",
    Address:
      "Lot 29, Kawasan Industri Bentong\n28700 Bentong\nPahang Darul Makmur",
    Tel: "09- 222 0088",
    Fax: "09-22 32296",
    Email: "myauto088@gmail.com",
    Area: "BENTONG",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 716,
    Name: "Sin Fatt Hing Mudguard & Spraying Sdn Bhd",
    Address: "Batu 2 , Jalan Temerloh\n28300 Triang\nPahang Darul Makmur",
    Tel: "09- 250 5299\n012- 900 3329\n012- 972 8011",
    Fax: "09- 250 5704",
    Email: "sinfatthing@yahoo.com",
    Area: "TRIANG",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 717,
    Name: "Soon Fatt Car Services Centre Sdn Bhd",
    Address:
      "Lot 32, Kawasan Perindustrian Jerantut\n27000 Jerantut\nPahang Darul Makmur",
    Tel: "09- 266 4100",
    Fax: "09- 266 1100",
    Email: "soonfatt1100@hotmail.com",
    Area: "JERANTUT",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 718,
    Name: "Soon Lee Mudguard & Spray Works Sdn Bhd",
    Address: "Lot 1427, Batu 42\nJalan Maran\n26030 Maran\nPahang Darul Makmur",
    Tel: "09- 478 0480",
    Fax: "09- 478 9593",
    Email: "slmswslg@gmail.com",
    Area: "MARAN",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 719,
    Name: "Temerloh Workshop Sdn Bhd",
    Address:
      "Batu 1(Seberang) Jalan Maran\n28000 Temerloh\nPahang Darul Makmur",
    Tel: "09- 297 2297",
    Fax: "09- 297 2372",
    Email: "temerlohworkshop@gmail.com",
    Area: "TEMERLOH",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 632,
    Name: "Chop Chin Hooi Auto Services Sdn Bhd",
    Address:
      "398A- Jalan Taiping\nOff Jalan Perak\n11600\nPulau Pinang\nPenang (Island)",
    Tel: "04- 281 7542\n04- 281 7544",
    Fax: "04- 281 1542",
    Email: "chinhoois@gmail.com\nchinhoois@hotmail.com",
    Area: "PULAU PINANG",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 633,
    Name: "Lean Lee Welding & Spray Painting Sdn Bhd",
    Address:
      "1235 Lorong Perusahaan Sg Lokan 5\nKawasan Perindustrian Sg Lokan (ACKU), MK\n16 Bagan Lallang\n13400\nButterworth\nPenang (Seberang Perai)",
    Tel: "04- 310 8686\n04- 310 8688",
    Fax: "04- 310 8687",
    Email: "llwsp@leanlee.com.my",
    Area: "BUTTERWORTH",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 634,
    Name: "Soon Hin Service & Repair Sdn Bhd",
    Address:
      "No. 91-K, Jalan Trusan,\nJelutong Barat, Jelutong,\n10150\nPulau Pinang\nPenang (Island)",
    Tel: "04- 282 8426",
    Fax: "04- 282 1024",
    Email: "soonhinpg@gmail.com",
    Area: "PULAU PINANG",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 635,
    Name: "Shen Wah Auto Services Sdn. Bhd",
    Address:
      "No 36, Solok Rawana\nOff Jalan P. Ramlee\n10460 Pulau Pinang\nPulau Pinang",
    Tel: "012- 5791188\n04- 2813072",
    Fax: "04- 2817101",
    Email: "shenwahautoservices@yahoo.com",
    Area: "PULAU PINANG",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 636,
    Name: "Syarikat Khor Motor Service Sdn Bhd",
    Address:
      "No 365, Jalan Tan Sri Teh Ewe Lim\n11600 Pulau Pinang\nPulau Pinang",
    Tel: "04-281 7080",
    Fax: "04-281 8942",
    Email: "khormotor@gmail.com",
    Area: "PULAU PINANG",
    Status: 0,
    State: "Penang",
  },
  {
    "Unique ID": 637,
    Name: "Tong Fong Motor Services Sdn Bhd",
    Address:
      "Lot 1143 MK 13\nJalan Kolam Ikan\n11900 Bayan Lepas\nPulau Pinang",
    Tel: "04-641 3886 / 012-486 8079",
    Fax: "04-642 5886",
    Email: "tongfongmotor@gmail.com",
    Area: "BAYAN",
    Status: 0,
    State: "Penang",
  },
  {
    "Unique ID": 638,
    Name: "A-Automobile Body Works Sdn Bhd",
    Address:
      "No. 322, Jalan Tanjung Tokong,\n10470 Pulau Pinang\nPenang (Island)",
    Tel: "04- 891 3333",
    Fax: "04- 899 9977",
    Email: "automobile99@yahoo.com",
    Area: "PULAU PINANG",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 639,
    Name: "Chan Panel Beating Sdn Bhd",
    Address:
      "130-H, Lintang Kampung Rawa 1\n10150 Pulau Pinang\nPenang (Island)",
    Tel: "04- 281 9217",
    Fax: "04- 282 0381",
    Email: "cpbpenang@gmail.com",
    Area: "PULAU PINANG",
    Status: 0,
    State: "Penang",
  },
  {
    "Unique ID": 640,
    Name: "Jsar Jaya Sdn Bhd",
    Address: "40-M Macalister Road\n10400 Pulau Pinang\nPenang (Island)",
    Tel: "04- 2261511 / 04- 228 5279",
    Fax: "04- 228 9584",
    Email: "jsar_jaya@yahoo.com",
    Area: "PULAU PINANG",
    Status: 0,
    State: "Penang",
  },
  {
    "Unique ID": 641,
    Name: "Kean Hin Spray Painting & Auto Car Repair Sdn Bhd",
    Address:
      "Lot 1656, Mk 13 Jalan Relau\n11900 Bayan Lepas\nPulau Pinang\nPenang (Island)",
    Tel: "04- 644 5729\n04- 646 6219",
    Fax: "04- 644 3729",
    Email: "keanhinspraypainting@gmail.com",
    Area: "BAYAN LEPAS",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 642,
    Name: "PG Leong Car-Body Repairs Sdn Bhd",
    Address:
      "No. 25G, PTN Jalan Osman B Kadir Lit\n10150 Pulau Pinang\nPenang (Island)",
    Tel: "04- 282 8914\n012- 330 6914",
    Fax: "04- 282 8914",
    Email: "pgleong_car60@yahoo.com",
    Area: "PULAU PINANG",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 643,
    Name: "SBB Automobile Sdn Bhd",
    Address:
      "40, East Jelutong (Beside Jelutong\nExpressway)\nGeorgetown\n11600 Pulau Pinang\nPenang (Island)",
    Tel: "04- 281 1766",
    Fax: "04- 282 9766",
    Email: "sbbautopg@gmail.com",
    Area: "PULAU PINANG",
    Status: 0,
    State: "Penang",
  },
  {
    "Unique ID": 644,
    Name: "Syarikat Chin Huat & Sons Motor Sdn Bhd",
    Address: "151-A , Presgrave Street\n10300 Pulau Pinang\nPenang (Island)",
    Tel: "04- 262 9282",
    Fax: "04- 262 7302",
    Email: "syktchinhuat@gmail.com",
    Area: "PULAU PINANG",
    Status: 0,
    State: "Penang",
  },
  {
    "Unique ID": 645,
    Name: "Tenggara Workshop Sdn Bhd",
    Address:
      "Lot PT 1599 (Unit 2)\nJalan Baru Maung\n11900 Bayan Lepas\nPenang (Island)",
    Tel: "04- 626 6240",
    Fax: "04 -626 4133",
    Email: "syarikat_tenggara@yahoo.com",
    Area: "BAYAN LEPAS",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 646,
    Name: "Yik Peng Motor Workshop Sdn Bhd",
    Address:
      "No.1940, Jalan Besar\nSungai Bakap\n14200 Pulau Pinang\nPenang (Island)",
    Tel: "04- 582 1750",
    Fax: "04- 582 1751",
    Email: "yikpengmw@gmail.com",
    Area: "PULAU PINANG",
    Status: 0,
    State: "Penang",
  },
  {
    "Unique ID": 647,
    Name: "Chin Lak Motor Sdn Bhd",
    Address: "No 2174, Main Road\n14300 Nibong Tebal\nPenang (Seberang Perai)",
    Tel: "04- 593 1580",
    Fax: "04-5 93 1340",
    Email: "chinlak2u@gmail.com",
    Area: "NIBONG TEBAL",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 648,
    Name: "H.B.Motor Workshop Sdn Bhd",
    Address:
      "1736, Jalan Berapit\n14000 Bukit Mertajam\nPenang (Seberang Perai)",
    Tel: "04- 539 2593/ 538 9297",
    Fax: "04- 539 6292",
    Email: "heapbee.hb@gmail.com\nkriss2626@gmail.com",
    Area: "BUKIT MERTAJAM",
    Status: 0,
    State: "Penang",
  },
  {
    "Unique ID": 649,
    Name: "Hooi Professional Vehicle Servicing Sdn Bhd",
    Address:
      "No.227 Kampung Teluk (Perai)\nJalan Baru\n13700 Perai\nPenang (Seberang Perai)",
    Tel: "04- 399 3723",
    Fax: "04- 397 4723",
    Email: "hooimotor@live.com",
    Area: "PERAI",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 650,
    Name: "Kein Chuan Motor Workshop Sdn Bhd",
    Address:
      "No.7069, Jalan Lahar Yooi\nTasik Gelugor\n13300 Butterworth\nPenang (Seberang Perai)",
    Tel: "04- 356 7726",
    Fax: "04- 356 7682",
    Email: "keinchuan@hotmail.com",
    Area: "BUTTERWORTH",
    Status: 0,
    State: "Penang",
  },
  {
    "Unique ID": 651,
    Name: "Lay Welding Spray Painting Sdn Bhd",
    Address: "5097, Jalan Siram,\n12100 Butterworth,\nPulau Pinang.",
    Tel: "04- 390 1080",
    Fax: null,
    Email: "lwspsb@yahoo.com",
    Area: "BUTTERWORTH",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 652,
    Name: "Tatt Seng Jaya Automobile Sdn Bhd",
    Address:
      "Plot 26, LPBM 9, Mk. 13\nKawasan Perindustrian Bukit Minyak\n14100 Simpang Ampat\nPenang (Seberang Perai)",
    Tel: "04- 507 7020",
    Fax: "04- 507 8146",
    Email: "tsjaya2004@gmail.com",
    Area: "SIMPANG AMPAT",
    Status: 0,
    State: "Penang",
  },
  {
    "Unique ID": 653,
    Name: "Teong Chai Spray Painting Sdn Bhd",
    Address: "No. 5097 Jalan Siram\n12100 Butterworth\nPenang (Seberang Perai)",
    Tel: "04 – 331 4008 / 012 – 483 4008",
    Fax: "04 – 332 4008",
    Email: "tcspray@hotmail.com",
    Area: "BUTTERWORTH",
    Status: 0,
    State: "Penang",
  },
  {
    "Unique ID": 654,
    Name: "Wellesley Motor Workshop (PG) Sdn Bhd",
    Address:
      "TBP 6424, MK. 13 Jalan Mengkudu Juru\n14100 Bukit Mertajam\nPenang (Seberang Perai)",
    Tel: "04- 508 8588",
    Fax: "04- 507 7939",
    Email: "wm24hour@gmail.com",
    Area: "BUKIT MERTAJAM",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 720,
    Name: "Syarikat Motor Peak Lik Wong Sdn Bhd",
    Address:
      "K2, Sri Mariamman Lane\nSg. Pari\n30200\nIpoh\nPerak Darul Ridzuan",
    Tel: "05- 243 5555",
    Fax: "05- 241 7332",
    Email: "peaklikwong@gmail.com\npeaklikwong@yahoo.com",
    Area: "IPOH",
    Status: 0,
    State: "Perak",
  },
  {
    "Unique ID": 721,
    Name: "Lau Motor Workshop Menglembu (PK) Sdn Bhd",
    Address:
      "Lot 34627, Jalan Hala Perushaan\nMenglembu 15\nMenglembu\n30200\nIpoh\nPerak Darul Ridzuan",
    Tel: "05- 282 6666",
    Fax: "05- 281 6326",
    Email: "laumotor@gmail.com",
    Area: "IPOH",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 722,
    Name: "Beng Kamunting Auto Service Sdn Bhd",
    Address:
      "Lot 18884, Jalan Perusahaan 8,\nKawasan Perusahaan Kamunting,\n34600 Kamunting\nPerak Darul Ridzuan",
    Tel: "019- 775 0811\n05- 891 0844",
    Fax: "05- 891 3811",
    Email: "bengkmtg@gmail.com",
    Area: "KAMUNTING",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 723,
    Name: "Heap Lee Motor Sdn Bhd",
    Address:
      "Lot Q5A Lumut Port Industrial Park\nJalan Besar, Kampung Acheh\n32000 Sitiawan\nPerak Darul Ridzuan",
    Tel: "05-691 3972 / 05-691 0325",
    Fax: null,
    Email: "heaplee@hotmail.com",
    Area: "SITIAWAN",
    Status: 0,
    State: "Perak",
  },
  {
    "Unique ID": 724,
    Name: "Ipoh Soo Kee Motors Sdn Bhd",
    Address:
      "No 9, Hala Perusahaan Menglembu 4\n31450 Ipoh\nPerak Darul Ridzuan",
    Tel: "05- 282 2501\n05- 282 1173",
    Fax: "05- 282 7202",
    Email: "iskmsb@gmail.com",
    Area: "IPOH",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 725,
    Name: "Kg. Tawas Harp Hin Motor Sdn Bhd",
    Address:
      "No. 1, Laluan Kuala Kangsar 9\nOff Jalan Kuala Kangsar\n30010 Ipoh\nPerak Darul Ridzuan",
    Tel: "05- 506 4161\n05- 506 6666",
    Fax: "05- 506 4162",
    Email: "kthhm_ngor@yahoo.com.my",
    Area: "IPOH",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 726,
    Name: "Yew Nean Motor (Bidor) Sdn Bhd",
    Address:
      "Lot 3481, Batu 1, Jalan Sungkai\n35500 Bidor\nPerak Darul Ridzuan",
    Tel: "05- 434 8333\n05- 434 9333",
    Fax: "05- 434 7333",
    Email: "unionmtr88@gmail.com\nunionmtr@yahoo.com",
    Area: "BIDOR",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 727,
    Name: "Bengkel Motor Kok Ken Sdn Bhd",
    Address:
      "No.1 Laluan Industri Lahat 5\nKawasan Perindustrian Rima\n31500 Lahat\nPerak Darul Ridzuan",
    Tel: "05- 322 2859",
    Fax: "05- 322 9691",
    Email: "bmkk@time.net.my\nbmkkipoh@gmail.com",
    Area: "LAHAT",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 728,
    Name: "Cum Yin Motor (Teluk Intan) Sdn Bhd",
    Address:
      "Lot 2887, Batu 4, Jalan Maharaja Lela\n36000 Teluk Intan\nPerak Darul Ridzuan",
    Tel: "05- 621 5588\n05- 621 5599",
    Fax: "05- 621 1021",
    Email: "cumyinmotor@yahoo.com.my",
    Area: "TELUK INTAN",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 729,
    Name: "Fah Kee Motor Sdn Bhd",
    Address:
      "Lot 41319, Jalan Bercham\nKawasan Perindustrian Bercham, Bercham\n31400 Ipoh\nPerak Darul Ridzuan",
    Tel: "05- 546 8999",
    Fax: "05- 547 3220",
    Email: "fahkeemotorsb@gmail.com",
    Area: "IPOH",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 730,
    Name: "Gerik Jet Set Workshop Sdn Bhd",
    Address:
      "Lot 11883, Jalan Intan P.O. Box 3\n33300 Gerik\nPerak Darul Ridzuan",
    Tel: "05- 791 2790\n05- 791 0933",
    Fax: "05- 791 2531",
    Email: "jetsetgerik@gmail.com",
    Area: "GERIK",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 731,
    Name: "Gopeng Weng Kien Motor Sdn Bhd",
    Address:
      "Lot 33, Gopeng Industrial Park, Phase 3\n31600 Gopeng\nPerak Darul Ridzuan",
    Tel: "05- 357 3388\n05- 357 3339",
    Fax: "05- 357 3366",
    Email: "gwkm_4099@yahoo.com.my",
    Area: "GOPENG",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 732,
    Name: "Hak Soon Spray Painting Workshop (M) Sdn Bhd",
    Address:
      "Lot 0-5, Lumut Port Industrial Park, Kg. Acheh\n32000 Sitiawan\nPerak Darul Ridzuan",
    Tel: "05- 691 2094",
    Fax: "05- 691 2568",
    Email: "haksoon05@gmail.com",
    Area: "SITIAWAN",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 733,
    Name: "Haup Sing Trading Sdn Bhd",
    Address:
      "Lot 22256, Batu 2\nJalan Jelapang\n30020 Ipoh\nPerak Darul Ridzuan",
    Tel: "05- 526 3385\n05- 526 1532\n05- 526 825",
    Fax: "05- 526 7633",
    Email: "haupsing@gmail.com",
    Area: "IPOH",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 734,
    Name: "Hee Yau Tuck & Sons Motor Sdn Bhd",
    Address:
      "Lot 33261, Batu 17, Jalan Beruas\n32400 Ayer Tawar\nPerak Darul Ridzuan",
    Tel: "05- 672 2001",
    Fax: "05- 672 8001",
    Email: "hyts05@hotmail.com",
    Area: "AYER TAWAR",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 735,
    Name: "Hon Mudguard Sdn Bhd",
    Address: "No 43, Jalan Iskandar\n31900 Kampar\nPerak Darul Ridzuan",
    Tel: "05- 466 2722",
    Fax: "05- 466 3339",
    Email: "hon_mudguard@yahoo.com",
    Area: "KAMPAR",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 736,
    Name: "Ipoh Winson Auto Works Sdn Bhd",
    Address:
      "No. 14, Jalan Menglembu Jaya 2\nIndustri Menglembu Jaya\n31450 Menglembu\nPerak Darul Ridzuan",
    Tel: "05- 2829882",
    Fax: "05- 282 9882",
    Email: "ipohwinson12@gmail.com",
    Area: "MENGLEMBU",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 737,
    Name: "Kent Meng Motor Sdn Bhd",
    Address:
      "No. 27 & 29, Prsn. Bercham Selatan 20\nLight Industrial Bercham\n31400 Ipoh\nPerak Darul Ridzuan",
    Tel: "05- 546 4521",
    Fax: "05- 546 4521",
    Email: "kentmeng2699@yahoo.com",
    Area: "IPOH",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 738,
    Name: "Khien Zhou Enterprise Sdn Bhd",
    Address:
      "Lot 32849, Batu 50, Jalan Beruas\n32400 Ayer Tawar\nPerak Darul Ridzuan",
    Tel: "05- 672 5184",
    Fax: "05- 672 7618",
    Email: "kz_enterprise@hotmail.com\nkz_workshop@hotmail.com",
    Area: "AYER TAWAR",
    Status: 0,
    State: "Perak",
  },
  {
    "Unique ID": 739,
    Name: "Lim Chee Keong Motor Sdn Bhd",
    Address:
      "No. 25, Persiaran Pengkalan 4\nKawasan Perindustrian Pengkalan\n31500 Lahat\nPerak Darul Ridzuan",
    Tel: "05- 322 8554",
    Fax: "05- 322 3415",
    Email: "lckauto@yahoo.com",
    Area: "LAHAT",
    Status: 0,
    State: "Perak",
  },
  {
    "Unique ID": 740,
    Name: "LWS Motor Sdn Bhd (Formerly known as Lim Wing Sang Motor Sdn Bhd)",
    Address:
      "No.3 & 5, Persiaran Industri Rapat 1\nPerindustrian Ringan Sri Rapat\n(Taman Song Choon)\n31350 Ipoh\nPerak Darul Ridzuan",
    Tel: "05- 3131111",
    Fax: "05- 312 8311",
    Email: "lwsmotor@gmail.com",
    Area: "IPOH",
    Status: 0,
    State: "Perak",
  },
  {
    "Unique ID": 741,
    Name: "Pembaiki Kereta Chin Hong Sdn Bhd",
    Address:
      "Lot 1282, Jalan Kuala Kangsar\n34700 Taiping\nPerak Darul Ridzuan",
    Tel: "05- 847 9484",
    Fax: "05- 847 0484",
    Email: "pkch1543@yahoo.com\nngcpin@live.com",
    Area: "TAIPING",
    Status: 0,
    State: "Perak",
  },
  {
    "Unique ID": 742,
    Name: "Pooh Hui Paint Spraying Workshop Sdn Bhd",
    Address: "No 99, Kampung Bintang\n32000 Sitiawan\nPerak Darul Ridzuan",
    Tel: "05- 692 7169",
    Fax: "05- 691 0803",
    Email: "poohkuiworkshop@hotmail.com",
    Area: "SITIAWAN",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 743,
    Name: "Sin Chun Yeang Motor Sdn Bhd",
    Address:
      "No. 89 Persiaran Klebang 1, Kawasan\nPerindustrian IGB, Off Jalan Kuala Kangsar\n31200 Ipoh\nPerak Darul Ridzuan",
    Tel: "05- 293 1010\n05- 293 1011",
    Fax: "05- 293 1012",
    Email: "scymsb@gmail.com",
    Area: "IPOH",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 744,
    Name: "Slim Motor Workshop (M) Sdn Bhd",
    Address:
      "PT 2562 Bandar Baru Slim River\n35800 Slim River\nPerak Darul Ridzuan",
    Tel: "05- 452 9220",
    Fax: "05- 452 0335",
    Email: "slimmotor@gmail.com",
    Area: "SLIM RIVER",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 745,
    Name: "Soon Thiam Motor Sdn Bhd",
    Address:
      "PT 2477, Taman Industri Maju Perak\n36700 Langkap\nPerak Darul Ridzuan",
    Tel: "05- 659 2389",
    Fax: "05- 659 4560",
    Email: "soonthiammotor@hotmail.com",
    Area: "LANGKAP",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 746,
    Name: "Syarikat Bah Bah Motors Sdn Bhd",
    Address:
      "Lot. 2469, Jalan Sultan Iskandar Shah\nP.O.Box 78\n33000 Kuala Kangsar\nPerak Darul Ridzuan",
    Tel: "05- 776 1287\n05- 776 4735",
    Fax: "05- 777 4978",
    Email: "bahbahmotors@gmail.com",
    Area: "KUALA KANGAR",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 747,
    Name: "T.M. Wong Workshop Sdn Bhd",
    Address:
      "Lot 4599, Jalan Slim Baru\n35900 Tanjong Malim\nPerak Darul Ridzuan",
    Tel: "05- 459 9822",
    Fax: "05- 459 5893",
    Email: "tmwong1995@gmail.com",
    Area: "TANJONG MALIM",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 748,
    Name: "Tapah Motors Sdn Bhd",
    Address:
      "Lot 387, Batu 1 1/2, Jalan Pahang\n35000 Tapah\nPerak Darul Ridzuan",
    Tel: "05- 401 1577\n016- 558 8838\n016- 558 0225",
    Fax: "05- 401 1578",
    Email: "thevakumar77@yahoo.co.uk",
    Area: "TAPAH",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 749,
    Name: "Top Diversified Sdn Bhd",
    Address:
      "lot 7405 Lorong Kilang 4\nTupai Industrial Area\n34000 Taiping\nPerak Darul Ridzuan",
    Tel: "05- 806 3180",
    Fax: "05- 805 3180",
    Email: "top_collission@yahoo.com; danloh19@yahoo.com; dloh7380@gmail.com",
    Area: "TAIPING",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 750,
    Name: "True Results Sdn Bhd",
    Address:
      "Lot 305885 Hala Rapat Baru 19\nKawasan Perindustrian Ringan Kinta Jaya\n31350 Ipoh\nPerak Darul Ridzuan",
    Tel: "05- 312 5868",
    Fax: "05- 311 2868",
    Email: "trueresults04@yahoo.com",
    Area: "IPOH",
    Status: 0,
    State: "Perak",
  },
  {
    "Unique ID": 795,
    Name: "Lean Hup Workshop Sdn Bhd",
    Address: "KM 13.9, Jalan Arau-Kodiang\n02600 Arau\nPerlis Indera Kayangan",
    Tel: "04- 986 1201",
    Fax: "04- 986 3678",
    Email: "leanhupworkshop@yahoo.com",
    Area: "ARAU",
    Status: 1,
    State: "Perlis",
  },
  {
    "Unique ID": 796,
    Name: "Wei Lee Workshop Sdn Bhd",
    Address:
      "0166A. BT 3/4\nJalan Baru Bohor Temak\n1000 Kangar\nPerlis Indera Kayangan",
    Tel: "04- 976 3790",
    Fax: "04- 976 3790",
    Email: "weileewl@hotmail.com\nweileewl@yahoo.com",
    Area: "KANGAR",
    Status: 1,
    State: "Perlis",
  },
  {
    "Unique ID": 577,
    Name: "Sin Hup Foh Motor Sdn Bhd",
    Address:
      "Lot 28, Lok Kawi Industrial Estate,\nPhase 2B, Jalan Lama Papar,\n89580\nKota Kinabalu\nSabah",
    Tel: "088- 750 222\n088- 750 226\n088- 750 229",
    Fax: "088- 750 225",
    Email: "hup_foh@hotmail.com",
    Area: "KOTA KINABALU",
    Status: 1,
    State: "Sabah",
  },
  {
    "Unique ID": 578,
    Name: "KK Sri Jaya Motor Sdn Bhd",
    Address:
      "Lot 2, Jalan Ramatah- Putatan\nPenampang\n88300\nKota Kinabalu\nSabah",
    Tel: "088- 773 990\n088- 771 989",
    Fax: "088- 772 990",
    Email: "sjmotorkk@gmail.com",
    Area: "KOTA KINABALU",
    Status: 1,
    State: "Sabah",
  },
  {
    "Unique ID": 579,
    Name: "Am Leong Engineering Sdn Bhd",
    Address: "KM 1, Jalan Ranau Tambunan,\nP.O. Box 132\n89308 Ranau\nSabah",
    Tel: "088- 875 608\n088- 879 608\n019- 851 8608\n019- 897 9818",
    Fax: "088-876 608",
    Email: "amleong2@gmail.com\namleong.custcare@gmail.com",
    Area: "RANAU",
    Status: 1,
    State: "Sabah",
  },
  {
    "Unique ID": 580,
    Name: "Bengkel FW Sdn Bhd",
    Address:
      "TB 2946, Lot B24, SEDCO Light Industrial\nEstate, Batu 3, Jalan Apas\n91000 Tawau\nSabah",
    Tel: "089- 911 853 / 911 953",
    Fax: "089- 911 831",
    Email: "forwardliew@yahoo.com",
    Area: "TAWAU",
    Status: 0,
    State: "Sabah",
  },
  {
    "Unique ID": 581,
    Name: "Bengkel Setiamaju Sdn Bhd",
    Address:
      "P.O.Box 457, Kg. Dambai Nt 013070892\nJalan Tuaran By Pass\n88450 Tuaran\nSabah",
    Tel: "088- 491 139\n088- 490 070\n019- 880 5558",
    Fax: "088- 491 139",
    Email: "son_leong30@yahoo.com",
    Area: "TUARAN",
    Status: 1,
    State: "Sabah",
  },
  {
    "Unique ID": 582,
    Name: "Bengkel Soon Lee (Ldu) Sdn Bhd",
    Address:
      "Lot 7 & 8, Jalan Dabak ,\nJalan Dam, P.O.Box No. 60467\n91114 Lahad Datu\nSabah",
    Tel: "089- 882 785\n089- 883 785",
    Fax: "089- 883 034",
    Email: "soonleesb@gmail.com\nmswong@bengkelsoonlee.com.my",
    Area: "LAHAD DATU",
    Status: 1,
    State: "Sabah",
  },
  {
    "Unique ID": 583,
    Name: "Bengkel Wilson (Tawau) Sdn Bhd",
    Address: "TB 775, Mile 4,\nJalan Apas P.O.Box No.37\n91007 Tawau\nSabah",
    Tel: "089- 912 793",
    Fax: "089- 912 007",
    Email: "wilsonmotor@yahoo.com",
    Area: "TAWAU",
    Status: 1,
    State: "Sabah",
  },
  {
    "Unique ID": 584,
    Name: "Bengkel Yong Inanam Sdn Bhd",
    Address:
      "No.69, Noutun Baru,Tauran Road\nP.O.Box A-42, Inanam\n89352 Kota Kinabalu\nSabah",
    Tel: "088- 420 400",
    Fax: "088- 428 952",
    Email: "yonginanam@ymail.com\nyonginanam@ymail.com",
    Area: "KOTA KINABALU",
    Status: 1,
    State: "Sabah",
  },
  {
    "Unique ID": 585,
    Name: "Cheong Hong Workshop Sdn Bhd",
    Address:
      "KM3, Jalan Datuk Panglima Banting\nKibabaig,Penampang\nP.O.Box 20218 , Luyang\n88759 Kota Kinabalu\nSabah",
    Tel: "088- 711 388\n088- 727 386",
    Fax: "088- 720 387",
    Email: "chwsb2@yahoo.com",
    Area: "KOTA KINABALU",
    Status: 1,
    State: "Sabah",
  },
  {
    "Unique ID": 586,
    Name: "Fung Ngap Engineering Sdn Bhd",
    Address:
      "Batu 5 1/2 Jalan Kolombong Inanam\nP. O. Box 22673 Luyang\n88786 Kota Kinabalu\nSabah",
    Tel: "088-438 386",
    Fax: "088-433 387",
    Email: "fungngap@gmail.com",
    Area: "KOTA KINABALU",
    Status: 0,
    State: "Sabah",
  },
  {
    "Unique ID": 587,
    Name: "G & J Supply and Service Sdn Bhd",
    Address:
      "KM 2, Papar Beaufort Highway, NT36973\nJalan Bukit Manggis, Kg Lakut\nPeti Surat 781\n89608 Papar\nSabah",
    Tel: "088- 915 968",
    Fax: "088- 915 790",
    Email: "gnjworkshop@gmail.com",
    Area: "PAPAR",
    Status: 1,
    State: "Sabah",
  },
  {
    "Unique ID": 588,
    Name: "Hup Foh Engineering Sdn Bhd",
    Address:
      "TB 11898, Lot No. SD 6, Landmark Light\nIndustrial Park, Batu 4 1/2, Jalan Apas,\nTawau, 91000 Tawau\nSabah",
    Tel: "017- 228 8152",
    Fax: null,
    Email: "bhupfoh@yahoo.com",
    Area: "TAWAU",
    Status: 1,
    State: "Sabah",
  },
  {
    "Unique ID": 589,
    Name: "Hup Foh Master Sdn Bhd",
    Address:
      "Batu 2 ½ Kg. Wawasan\nJalan Dam\nP.O. Box 61696\n91125 Lahat Datu\nSabah",
    Tel: "089- 886 728",
    Fax: "089- 886 712",
    Email: "hupfohmaster1@gmail.com",
    Area: "LAHAD DATU",
    Status: 1,
    State: "Sabah",
  },
  {
    "Unique ID": 590,
    Name: "Joo Hwang Workshop Sdn Bhd",
    Address: "P.O.Box 511 Pekan Goshen\n89107 Kota Marudu\nSabah",
    Tel: "088- 662 662",
    Fax: "088- 662 612",
    Email: "jh_workshop@yahoo.com",
    Area: "KOTA MARUDU",
    Status: 1,
    State: "Sabah",
  },
  {
    "Unique ID": 591,
    Name: "Kheong Kong Workshop Sdn Bhd",
    Address: "Mile 3 1/2 , North Road\nP.O.Box No. 903\n90711 Sandakan\nSabah",
    Tel: "089- 216 112",
    Fax: "089- 237 112",
    Email: "kheongkong@hotmail.com",
    Area: "SANDAKAN",
    Status: 1,
    State: "Sabah",
  },
  {
    "Unique ID": 592,
    Name: "LB Performance Auto Works Sdn Bhd",
    Address: "Kg Mawao, Membakut\nPeti Surat 367\n89728 Membakut\nSabah",
    Tel: "087- 886 150",
    Fax: "087- 886 149",
    Email: "lbperformance@ymail.com",
    Area: "MEMBAKUT",
    Status: 1,
    State: "Sabah",
  },
  {
    "Unique ID": 593,
    Name: "L.B Weng Motor Sdn Bhd",
    Address:
      "Batu 6 1/2 Jalan Putatan\nP.O.Box 13347\n88837 Kota Kinabalu\nSabah",
    Tel: "088-771 662",
    Fax: "088-761 067",
    Email: "lbweng@yahoo.com",
    Area: "KOTA KINABALU",
    Status: 0,
    State: "Sabah",
  },
  {
    "Unique ID": 594,
    Name: "N.S. Auto Works (Marudu) Sdn Bhd",
    Address: "Jalan Tandek, KM 2\nP.O Box 400\n89108 Kota Marudu\nSabah",
    Tel: "088- 661 522",
    Fax: "088- 662 522",
    Email: "nsautomb@hotmail.com",
    Area: "KOTA MARUDU",
    Status: 1,
    State: "Sabah",
  },
  {
    "Unique ID": 595,
    Name: "Sin Aik Bee Auto Centre Sdn Bhd",
    Address: "Batu 1, Jalan Bakiau\nP.O. Box 588\n89008 Keningau\nSabah",
    Tel: "087- 339 346\n087- 338 646",
    Fax: "087- 341 822",
    Email: "sinaikbee08@gmail.com\nhkhwee@gmail.com",
    Area: "KENINGAU",
    Status: 1,
    State: "Sabah",
  },
  {
    "Unique ID": 596,
    Name: "Stephen Motors Sdn Bhd",
    Address:
      "Batu 9, Jalan Tuaran, Menggatal\nP.O. Box A-140\n89357 Inanam\nSabah",
    Tel: "088- 226 617/ 016- 832 1583",
    Fax: "088 -498 067",
    Email: "stphmtrs@hotmail.com\nstephenmtr@hotmail.com",
    Area: "INANAM",
    Status: 0,
    State: "Sabah",
  },
  {
    "Unique ID": 597,
    Name: "Terajasa Automobile Sdn Bhd",
    Address:
      "Lot 188,Lorong Sedco 7,\nSedco Light Industrial Estate, P.O.Box 2838\n90731 Sandakan\nSabah",
    Tel: "089-222 555/ 222 324",
    Fax: "089-273 830",
    Email: "terajasa@gmail.com",
    Area: "SANDAKAN",
    Status: 0,
    State: "Sabah",
  },
  {
    "Unique ID": 598,
    Name: "Tong Seng Auto Service Centre Sdn Bhd",
    Address:
      "Mile 5, Grand Industrial Centre,\nPenampang Road,\n88300 Kota Kinabalu,\nSabah.",
    Tel: "088- 712 405/ 016- 830 2045",
    Fax: "088- 712 023",
    Email: "tsascsb@gmail.com\ntonytan_5@yahoo.com",
    Area: "KOTA KINABALU",
    Status: 0,
    State: "Sabah",
  },
  {
    "Unique ID": 599,
    Name: "Vun Lee Workshop Sdn Bhd",
    Address:
      "Lot 5, Bandar Kim Fung, Light Industrial Building\nMile 4, North Road, P. O. Box 191, PPJU\n90307 Sandakan\nSabah",
    Tel: "089- 216 337\n089- 226 337",
    Fax: "089- 236 337",
    Email: "vunlee88@hotmail.com",
    Area: "SANDAKAN",
    Status: 1,
    State: "Sabah",
  },
  {
    "Unique ID": 600,
    Name: "Yik Sin Auto Sdn Bhd",
    Address:
      "Lot No.2, Lorong Belimbing, Off Jalan Tuaran\nKolombong Mile 5 1/2\n88450 Kota Kinabalu\nSabah",
    Tel: "088- 385 711",
    Fax: "088- 385 712",
    Email: "yucyl555@gmail.com\nyiksinauto@gmail.com",
    Area: "KOTA KINABALU",
    Status: 1,
    State: "Sabah",
  },
  {
    "Unique ID": 601,
    Name: "Ah Seng Motor Sdn Bhd",
    Address:
      "No. 190, 4 1/2 Mile\nJalan Datuk Bandar Mustapha\n93350\nKuching\nSarawak",
    Tel: "082- 456 939\n082- 616 939",
    Fax: "082- 454 619\n082- 616 839",
    Email: "asmkho@pd.jaring.my\nasmo773@gmail.com",
    Area: "KUCHING",
    Status: 1,
    State: "Sarawak",
  },
  {
    "Unique ID": 602,
    Name: "Kiat Seng Welding Works Sdn Bhd",
    Address:
      "Lot 1358, Block 3\nJalan Primula Piasau Industrial Estate\n98000\nMiri\nSarawak",
    Tel: "085- 656 212",
    Fax: "085- 653 212",
    Email: "admin@kiatseng.com.my",
    Area: "MIRI",
    Status: 1,
    State: "Sarawak",
  },
  {
    "Unique ID": 603,
    Name: "PT Yew Motor Sdn Bhd",
    Address:
      "Lot 700, Mile 2, Bintulu Light Industrial\nEstate\nP.O.Box 515\n97008 Bintulu\nSarawak",
    Tel: "086- 331 631\n019- 854 1288",
    Fax: null,
    Email: "ptyewmotor@ymail.com",
    Area: "BINTULU",
    Status: 1,
    State: "Sarawak",
  },
  {
    "Unique ID": 604,
    Name: "Hiap Seng Motor Sdn Bhd",
    Address:
      "Lot 1963, Block 4\nPiasau Industrail Estate, Jalan Piasau\n98000 Miri\nSarawak",
    Tel: "085- 654 082",
    Fax: null,
    Email: "hiapsengmtr@gmail.com",
    Area: "MIRI",
    Status: 1,
    State: "Sarawak",
  },
  {
    "Unique ID": 605,
    Name: "Batu Niah Lee’s Workshop Sdn Bhd",
    Address:
      "Lot 597, Niah Junction\nP. O. Box 48, Pejabat Pos Mini\n98200 Batu Niah\nSarawak",
    Tel: "085- 737 296",
    Fax: "085 -736 159",
    Email: "leenp8@yahoo.com.my",
    Area: "BATU NIAH",
    Status: 1,
    State: "Sarawak",
  },
  {
    "Unique ID": 606,
    Name: "Bengkel Kereta Bahagia Sdn Bhd",
    Address: "Lot 353, Lorong 3\nJalan Semaba\n93250 Kuching\nSarawak",
    Tel: "082- 453 222\n082- 458 222",
    Fax: "082- 453 232",
    Email: "bahagia@bkb.com.my\nadmin@bkb.com.my",
    Area: "KUCHING",
    Status: 1,
    State: "Sarawak",
  },
  {
    "Unique ID": 607,
    Name: "EM Repair Centre Sdn Bhd",
    Address:
      "Lot 2095, Bulatan Road\nPiasau Industrial Estate\n98000 Miri\nSarawak",
    Tel: "085-436 189",
    Fax: "085-435 189",
    Email: "emmotor9999@gmail.com",
    Area: "MIRI",
    Status: 0,
    State: "Sarawak",
  },
  {
    "Unique ID": 608,
    Name: "Friendship Auto Workshop Sdn Bhd",
    Address:
      "No 114-116, Lot 41 & 42, Section 21 KTLD\nJalan Tun Haji Openg .P.O.Box 1878\n93000 Kuching\nSarawak",
    Tel: "082- 258 902",
    Fax: "082- 251 168",
    Email: "faw24tow@yahoo.com",
    Area: "KUCHING",
    Status: 1,
    State: "Sarawak",
  },
  {
    "Unique ID": 609,
    Name: "Glittern Motor Works Sdn Bhd",
    Address:
      "Sublot 27, Lot 1619, Taman Johawira\nJalan Sungai Nyigu\n97000 Bintulu\nSarawak",
    Tel: "086- 311 619\n086- 331 888",
    Fax: "086- 312 368",
    Email: "glittern@hotmail.com\nglitternmotorworkssb@gmail.com",
    Area: "BINTULU",
    Status: 1,
    State: "Sarawak",
  },
  {
    "Unique ID": 610,
    Name: "Holy Auto Service Centre Sdn Bhd",
    Address: "Lot 3946, Block 32, KLD\nJalan Sg. Nyigu\n97000 Bintulu\nSarawak",
    Tel: "086- 311 666",
    Fax: "086- 311 777",
    Email: "holyauto96@gmail.com\nholyauto@yahoo.com.my",
    Area: "BINTULU",
    Status: 1,
    State: "Sarawak",
  },
  {
    "Unique ID": 611,
    Name: "Huong Seng Motor Trading Sdn Bhd",
    Address:
      "No.16, Lorong Ding Lik Kong 39,\nJalan Ding Lik Kong\n96000 Sibu\nSarawak",
    Tel: "084-336 569 / 336 160",
    Fax: "084-316 569",
    Email: "hsws85@yahoo.com",
    Area: "SIBU",
    Status: 0,
    State: "Sarawak",
  },
  {
    "Unique ID": 612,
    Name: "Kereta Mewah Sdn Bhd",
    Address: "Lot 2227, Saberkas Commercial Centre\n98000 Miri\nSarawak",
    Tel: "085- 662 277",
    Fax: "085- 665 577",
    Email: "lester@kmmobil.com",
    Area: "MIRI",
    Status: 0,
    State: "Sarawak",
  },
  {
    "Unique ID": 613,
    Name: "Leader Garage (Btu) Sdn Bhd",
    Address:
      "Lot 3665, Block 32 , Kemena Land District\nJalan Sebiew\n97008 Bintulu\nSarawak",
    Tel: "086- 335 027",
    Fax: "086- 334 610",
    Email: "leadergarage@yahoo.com",
    Area: "BINTULU",
    Status: 1,
    State: "Sarawak",
  },
  {
    "Unique ID": 614,
    Name: "Mega Link General Autoworks (2008) Sdn Bhd",
    Address: "No.4B & 6A, Lorong Ding Lik Kong 20\n96000 Sibu\nSarawak",
    Tel: "084- 336 678",
    Fax: "084- 347 678",
    Email: "mega_kong@yahoo.com",
    Area: "SIBU",
    Status: 1,
    State: "Sarawak",
  },
  {
    "Unique ID": 615,
    Name: "Oren Auto Sdn Bhd",
    Address:
      "Lot 501, Block 26, Kemana Land District\nKidurong Industrial Area\n97000 Bintulu\nSarawak",
    Tel: "086-254 166",
    Fax: "086-253 177",
    Email: "oren.auto@hotmail.com",
    Area: "BINTULU",
    Status: 0,
    State: "Sarawak",
  },
  {
    "Unique ID": 616,
    Name: "Seng Huat Repair Centre Sdn Bhd",
    Address:
      "Lot 911, Block 218, 3rd Mile\nPenrissen Road\n93250 Kuching\nSarawak",
    Tel: "082- 461 882\n082- 461 772",
    Fax: "082- 461 882\n082- 688 892",
    Email: "senghuatkch@gmail.com",
    Area: "KUCHING",
    Status: 1,
    State: "Sarawak",
  },
  {
    "Unique ID": 617,
    Name: "Soon Huat Workshop Sdn Bhd",
    Address:
      "Lot 762, 1 1/4 Mile, Kubong Road\nP O Box 580\n98708 Limbang\nSarawak",
    Tel: "085- 213 641",
    Fax: "085- 215 330",
    Email: "shworkshop@yahoo.com.my",
    Area: "LIMBANG",
    Status: 1,
    State: "Sarawak",
  },
  {
    "Unique ID": 618,
    Name: "Syn Hock Hin Motor Sdn Bhd",
    Address:
      "No.303, Jalan Kung Phin, \nKampung Sudat,\n93250 Kuching,\nSarawak",
    Tel: "082-374 188/371 288",
    Fax: "082-372 276",
    Email: "hhmotor@pd.jaring.asia",
    Area: "KUCHING",
    Status: 0,
    State: "Sarawak",
  },
  {
    "Unique ID": 619,
    Name: "Tiong Ing Workshop & Services Sdn Bhd",
    Address:
      "Lot 60, Block 53, Mukah Land District Mukah\nNo.1, Jalan Haji Mohamad Fauzi\n96400 Mukah\nSarawak",
    Tel: "084- 875 662\n019- 818 9923",
    Fax: "084- 871 788\n019- 859 2240",
    Email: "tionging5796@gmail.com",
    Area: "MUKAH",
    Status: 1,
    State: "Sarawak",
  },
  {
    "Unique ID": 620,
    Name: "Yu Thian Motor Services Sdn Bhd",
    Address:
      "Lot 809, Block 8, MTLD\nDemark Laut Industrial Park Phase 3\n93050 Kuching\nSarawak",
    Tel: "082- 432 814\n082- 432 848\n082- 432 878",
    Fax: "082- 432 815\n082- 432 878",
    Email: "yu_thian@yahoo.com",
    Area: "KUCHING",
    Status: 1,
    State: "Sarawak",
  },
  {
    "Unique ID": 465,
    Name: "Skys Auto Workshop Sdn Bhd",
    Address:
      "No.2 Jalan Utama 2/15\nTaman Perindustrain Puchong Utama\n47100\nPuchong\nSelangor Darul Ehsan",
    Tel: "03- 8068 3122\n03- 8062 2122",
    Fax: "03- 8068 2122",
    Email: "skysauto@hotmail.com\nskysauto88@yahoo.com",
    Area: "PUCHONG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 502,
    Name: "Dynamic Auto Service Centre Sdn Bhd",
    Address:
      "Lot 29, Jalan Balakong\nBatu 11 Cheras\n43200\nKajang\nSelangor Darul Ehsan",
    Tel: "03- 9074 0516\n03- 9074 1516",
    Fax: "03- 9074 2516",
    Email: "dasc1388@gmail.com",
    Area: "KAJANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 503,
    Name: "Hikmat Selesa Sdn Bhd",
    Address:
      "Lot 1635, Jalan Haji Tarmidi\nRantau Panjang\n41200\nKlang\nSelangor Darul Ehsan",
    Tel: "03- 3291 2606",
    Fax: "03- 3291 1606",
    Email: "hikmatselesasb@gmail.com",
    Area: "KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 504,
    Name: "Lam Koong Sum Car Service Centre Sdn Bhd",
    Address:
      "Lot 11536, Persiaran Ehsan 1\nTaman Impian Ehsan, Jalan Balakong\n43300\nSeri Kembangan\nSelangor Darul Ehsan",
    Tel: "03- 8961 1111",
    Fax: "03- 8961 1437",
    Email: "mrkslam@pc.jaring.my",
    Area: "SERI KEMBANGAN",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 505,
    Name: "Law Tiam Chooi Auto Sdn Bhd",
    Address:
      "13, Jalan SU 26, Taman Selayang Utama\nSelayang\n68100\nBatu Caves\nSelangor Darul Ehsan",
    Tel: "03- 6120 4479, 03- 6137 2858",
    Fax: "03- 6120 2934",
    Email: "ltc_spcom@hotmail.com",
    Area: "BATU CAVES",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 506,
    Name: "Maxicergas Sdn Bhd",
    Address:
      "No.5, Jalan SBC 10,\nTaman Sri Batu Caves\n68100\nBatu Caves\nSelangor Darul Ehsan",
    Tel: "03- 6189 2255",
    Fax: "03- 6189 9889",
    Email: "maxicgsb@gmail.com\nmaxicgsb@yahoo.com",
    Area: "BATU CAVES",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 507,
    Name: "Rawang Yee Motor Sdn Bhd",
    Address:
      "Lot 1 , Jalan Perindustrian 1\nKawasan Perindustrian PKNS ,Batu 20\n48000\nRawang\nSelangor Darul Ehsan",
    Tel: "03- 6091 6250",
    Fax: "03- 6092 6250",
    Email: "admin@rawangyeemotor.com\nyeemotor@gmail.com",
    Area: "RAWANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 508,
    Name: "Skys Auto Workshop Sdn Bhd",
    Address:
      "No.2 Jalan Utama 2/15\nTaman Perindustrain Puchong Utama\n47100\nPuchong\nSelangor Darul Ehsan",
    Tel: "03- 8068 3122/ 03-8062 2122",
    Fax: "03- 8068 2122",
    Email: "skysauto@hotmail.com\nskysauto88@yahoo.com",
    Area: "PUCHONG",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 509,
    Name: "Soon Fatt Heng Motor Sdn Bhd",
    Address: "No. 2A, Jalan Kilang\n46050\nPetaling Jaya\nSelangor Darul Ehsan",
    Tel: "03-7781 5468/ 7781 5467",
    Fax: "03-7783 2536",
    Email: "motorsoonfattheng@yahoo.com",
    Area: "PETALING JAYA",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 510,
    Name: "SCS Auto Repair Sdn Bhd",
    Address:
      "87, Jalan Pendamar\n27/90, Section 27\n40400\nShah Alam\nSelangor Darul Ehsan",
    Tel: "03- 5103 6928\n03- 5192 8906 (Acc Dpt) ",
    Fax: "03-5192 9726",
    Email: "scsautorepairsb@gmail.com",
    Area: "SHAH ALAM",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 511,
    Name: "Shiun Motor Sdn Bhd",
    Address:
      "Lot 6, Jalan PBI 2\nPerindustrian Bukit Indah\n47000\nSungai Buloh\nSelangor Darul Ehsan",
    Tel: "03- 6143 1551\n03- 6143 1661\n03- 6143 1771\n03- 6143 1991",
    Fax: "03- 6143 1221",
    Email: "shiunmotor@yahoo.com.my",
    Area: "SUNGAI BULOH",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 512,
    Name: "New Thong Hing Motor Sdn Bhd",
    Address:
      "Lot 17502, Jalan 4\nTaman Selayang Baru Industrial Area\n68100, Batu Caves\nSelangor",
    Tel: "03- 6125 2828",
    Fax: "03- 6136 3639",
    Email: "newthmotor@gmail.com",
    Area: "BATU CAVES",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 513,
    Name: "Utama Motor Workshop ( Selangor ) Sdn Bhd",
    Address:
      "Lot 8860. Jalan Kim Chuan\nPandamaran\n42000\nKlang\nSelangor Darul Ehsan",
    Tel: "03- 3166 1999\n03- 3165 8820",
    Fax: "03- 3168 5229",
    Email: "umwssb@gmail.com",
    Area: "KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 514,
    Name: "Weng Oon Auto Sdn Bhd",
    Address:
      "50, Jalan Mas Jaya 2, Kawasan\nPerindustrian Mas Jaya, Off Jalan Hulu\nLangat\n43200\nCheras\nSelangor Darul Ehsan",
    Tel: "03- 9075 1133",
    Fax: "03- 9076 7068",
    Email: "mah@wengoon.com.my\nsherene@wengoon.com.my",
    Area: "CHERAS",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 515,
    Name: "C.T.S Workshop Sdn Bhd",
    Address:
      "No.8 & 10, Jalan TS 6/6\nTaman Industri Subang\n47510 Subang Jaya\nSelangor Darul Ehsan",
    Tel: "019- 213 8146\n03- 563 28655",
    Fax: "03- 56329044",
    Email: "ctsw777@gmail.com",
    Area: "SUBANG JAYA",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 516,
    Name: "Gallant Motors Sdn Bhd",
    Address:
      "No. 35, 36 & 37, Jalan Emas 14\nBandar Sungai Emas, Sungai Manggis\n42700 Banting\nSelangor Darul Ehsan",
    Tel: "03- 3181 2088\n03- 3187 9776",
    Fax: "03- 3187 3016",
    Email: "gallantmotors@gmail.com",
    Area: "BANTING",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 517,
    Name: "Tai Poh Motor Sdn Bhd",
    Address:
      "2-G & 2-1, Jalan Lembah Jaya 4\nTaman Industri Lembah Jaya\n68000 Ampang\nSelangor Darul Ehsan",
    Tel: "03- 4270 9632\n016- 225 9603",
    Fax: "03- 4270 0573",
    Email: "taipohmotor@gmail.com",
    Area: "AMPANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 518,
    Name: "United Teh Auto Repair Sdn Bhd",
    Address:
      "No.3 Jalan 39 Kawasan 16\noff Jalan Dato Mohd Sidin (Jln Connaught Bridge)\n41300 Klang\nSelangor Darul Ehsan",
    Tel: "03- 3341 8309\n03- 3342 1613",
    Fax: "03- 3342 3418",
    Email: "unitedteh@gmail.com",
    Area: "KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 519,
    Name: "Ah Lee Motor Works Sdn Bhd",
    Address:
      "Lot 14-A, Jalan Tukang 16/4\nSeksyen 16\n40200 Shah Alam\nSelangor Darul Ehsan",
    Tel: "03- 5524 2224",
    Fax: null,
    Email: "almw25@gmail.com",
    Area: "SUBANG JAYA",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 520,
    Name: "Ah Sang Motor Workshop Sdn Bhd",
    Address:
      "Lot 20, Jalan Utarid U5/26, Seksyen U5\nMah Sing Intergrated Industrial Park,\n40150 Shah Alam\nSelangor Darul Ehsan",
    Tel: "03- 7845 9019\n019- 628 7272\n019- 336 7115",
    Fax: "03-7845 9049",
    Email: "ahsang@po.jaring.my\nahsangmotor@hotmail.com",
    Area: "SHAH ALAM",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 521,
    Name: "Alam Saga Auto Service Sdn Bhd",
    Address:
      "No 42,44 & 46,Jalan Selat Selatan 2,\nOff Jalan Banting, Landpac Industrial Park\nPandamaran\n42000 Pelabuhan Klang\nSelangor Darul Ehsan",
    Tel: "03- 3165 3097",
    Fax: "03- 3165 2216",
    Email: "alamsaga@gmail.com",
    Area: "KLANG",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 522,
    Name: "Auto Carriage Resources Sdn Bhd",
    Address:
      "No. 38 & 40, Jalan TPP1/19,\nTaman Perindustrian Puchong,\n47100 Puchong, Selangor",
    Tel: "03- 8061 0926",
    Fax: "03- 8061 5973",
    Email: "acr_puchong@yahoo.com",
    Area: "PUCHONG",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 523,
    Name: "Bengkel Kereta Chop Bersatu Sdn Bhd",
    Address:
      "No 690 - C, Jalan Besar Sasaran\n45800 Jeram\nSelangor Darul Ehsan",
    Tel: "03- 3264 7069",
    Fax: "03- 3264 8900",
    Email: "chopbersatu@hotmail.com",
    Area: "JERAM",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 524,
    Name: "Bengkel Kereta Weng Yew Sdn Bhd",
    Address:
      "Lot 884C,D,E, Jalan Subang 9\nTaman Industri Sungai Penaga\n47630 Subang Jaya\nSelangor Darul Ehsan",
    Tel: "03- 8011 6526 / 012-316 0778",
    Fax: "03- 8081 0526",
    Email: "wengyew_sdnbhd@hotmail.com",
    Area: "SUBANG JAYA",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 525,
    Name: "Bengkel Kim Fook Sdn Bhd",
    Address:
      "Simpang Balak Batu 13\nJalan Cheras\n43000 Kajang\nSelangor Darul Ehsan",
    Tel: "03- 8736 5736",
    Fax: "03- 8734 4837",
    Email: "kmotor@hotmail.my",
    Area: "KAJANG",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 526,
    Name: "Car Mech Sdn Bhd",
    Address:
      "No. 1 Jalan PS7, Batu 8\nTaman Prima Selayang\n68100 Selayang\nSelangor Darul Ehsan",
    Tel: "03- 6120 1999",
    Fax: "03- 6120 3999",
    Email: "yee@carmech.com.my",
    Area: "SELAYANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 527,
    Name: "Car Medic Sdn Bhd",
    Address:
      "No. 1A , Jalan P4/7\nBandar Teknologi Kajang , Semenyih\n43500 Kajang\nSelangor Darul Ehsan",
    Tel: "03- 8723 6555",
    Fax: "03- 8723 0055",
    Email: "vlkwan@carmedic.com.my",
    Area: "KAJANG",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 528,
    Name: "Ching Seong Motors Sdn Bhd",
    Address:
      "Lot 14 & 16 . Section 51 A / 227 C\n46100 Petaling Jaya\nSelangor Darul Ehsan",
    Tel: "03-79576623/79574697 / 03- 79575692",
    Fax: "03-7955 8825 / 79588662",
    Email: "claims@chingseongmotorssb.com",
    Area: "PETALING JAYA",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 529,
    Name: "Chiong Brothers Motor Works Sdn Bhd",
    Address:
      "No.163 & 165, Jalan 27\nKaw 16, Sungai Rasa, P.O.Box 129\n41710 Klang\nSelangor Darul Ehsan",
    Tel: "03- 3342 4350/4352/ 4341, 016-332 4350",
    Fax: "03- 3343 9143",
    Email: "chongbro1@yahoo.com",
    Area: "KLANG",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 530,
    Name: "Choong Seng Motor Sdn Bhd",
    Address:
      "10 GM, Jalan Pandan Chaya 1/1\nPandan Cahaya\n68000 Ampang\nSelangor Darul Ehsan",
    Tel: "03- 4270 1391",
    Fax: "03- 4270 1799",
    Email: "choongsengmotor@hotmail.com",
    Area: "AMPANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 531,
    Name: "City Alignment Centre Sdn Bhd",
    Address:
      "Lot 1012, Jalan Kekwa, Kampung Kayu Ara\nDamansara Jaya\n47400 Petaling Jaya\nSelangor Darul Ehsan",
    Tel: "03- 7729 7668\n03- 7729 6518",
    Fax: "03- 7729 7662",
    Email: "claims@cagroup.com.my\ncityalig@gmail.com",
    Area: "PETALING JAYA",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 532,
    Name: "City Hundred Motor Sdn Bhd",
    Address:
      "Lot 1043, Jalan Cempaka,\nKampung Sungai Kayu Ara, Mukim\nDamansara\n47400 Petaling Jaya\nSelangor Darul Ehsan",
    Tel: "03- 7729 9933 ( 4 Lines )",
    Fax: "03- 7727 4657",
    Email: "admin@city100.com.my\ncityhundredmotor@gmail.com",
    Area: "PETALING JAYA",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 533,
    Name: "CMS Cars Express Sdn Bhd",
    Address:
      "No. 10, Jalan USJ 7/3, UEP\n47600 Subang Jaya\nSelangor Darul Ehsan",
    Tel: "03- 5636 7414",
    Fax: "03- 5637 8502",
    Email: "cms_cars@hotmail.com",
    Area: "SUBANG JAYA",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 534,
    Name: "F.W. Loh Motor Sdn Bhd",
    Address:
      "26, Jalan SR 2/5\nTaman Serdang Raya\n43300 Seri Kembangan\nSelangor Darul Ehsan",
    Tel: "03- 8941 3833",
    Fax: "03- 8941 7833",
    Email: "fwlohsdnbhd@gmail.com",
    Area: "SERI KEMBANGAN",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 535,
    Name: "G.Y. Auto Sdn Bhd",
    Address:
      "Lot 810 (Middle Section),Jalan Subang 5\nTaman Industri Subang\n47510 Subang Jaya\nSelangor Darul Ehsan",
    Tel: "03- 5636 1028\n03- 5632 2913",
    Fax: "03- 5636 1162\n03- 5631 6624",
    Email: "admin@gyauto.com.my",
    Area: "SUBANG JAYA",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 536,
    Name: "Gereg Auto Centre Sdn Bhd",
    Address:
      "No.1 & No.3, Jalan TS 6/6\nTaman Industri Subang\n47510 Subang Jaya\nSelangor Darul Ehsan",
    Tel: "03- 5631 2273",
    Fax: "03- 5631 0510",
    Email: "geregauto@gmail.com\njenniferchua_88@yahoo.com.my",
    Area: "SUBANG JAYA",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 537,
    Name: "His Auto Repair Services (M) Sdn Bhd",
    Address:
      "Lot 2065-B3, Jalan Kusta\nKampung Jaya Industrial Area\n47000 Sungai Buloh\nSelangor Darul Ehsan",
    Tel: "03- 6158 0555 / 03-6158 0666",
    Fax: "03- 6158 0008",
    Email: "his_auto@hotmail.com",
    Area: "SUNGAI BULOH",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 538,
    Name: "Hup Seng Collision Repair (Puchong)Sdn Bhd",
    Address: "No.6 Jalan TPP 6/12 ,Sek 6\n47100 Puchong\nSelangor Darul Ehsan",
    Tel: "03- 8068 5919",
    Fax: "03- 8068 5918",
    Email: "hup_seng@hotmail.com",
    Area: "PUCHONG",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 539,
    Name: "Ichiban Chiba Auto Service Sdn Bhd",
    Address:
      "No. 11, Jalan PS 4/1, Taman Prima Selayang\nKm 15 Off Jalan Rawang\n68100 Batu Caves\nSelangor Darul Ehsan",
    Tel: "03- 6120 8292",
    Fax: "03- 6120 5293",
    Email: "chiba_auto32@yahoo.com",
    Area: "BATU CAVES",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 540,
    Name: "K I United Motor Workshop Sdn Bhd",
    Address:
      "No.1 Jalan Rajawali 3\nBandar Puchong Jaya\n47100 Puchong\nSelangor Darul Ehsan",
    Tel: "03- 8075 7810",
    Fax: "03- 8075 9458",
    Email: "kiunited@gmail.com",
    Area: "PUCHONG",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 541,
    Name: "Keong Meng Motor Works Sdn Bhd",
    Address:
      "AL 121, Block J, 13th Miles, Jalan Subang\nKepong\n47000 Sungai Buloh\nSelangor Darul Ehsan",
    Tel: "03-6156 8981 / 012-232 8981",
    Fax: "03-6157",
    Email: "keongmengmotor@gmail.com",
    Area: "SUNGAI BULOH",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 542,
    Name: "Ket Keong Workshop Sdn Bhd",
    Address:
      "No 17 Jalan Sibu 16\nTaman Wahyu\n68100 Batu Caves\nSelangor Darul Ehsan",
    Tel: "03- 6257 1418",
    Fax: "03- 6257 1419",
    Email: "ketkeong2011@gmail.com",
    Area: "BATU CAVES",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 543,
    Name: "Kian Son Motor Sdn Bhd",
    Address:
      "AL-126, Welfare Road\nSungai Buloh New Village\n47000 Sungai Buloh\nSelangor Darul Ehsan",
    Tel: "03- 6156 3325",
    Fax: "03- 6156 0227",
    Email: "kiansontan@yahoo.com\nkiansonmotor_acc@yahoo.com",
    Area: "SUNGAI BULOH",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 544,
    Name: "Kim Foom Motor Sdn Bhd",
    Address:
      "No: 1 Jalan 2/10B\nSpring Crest Industrial Park,\n68100 Batu Caves\nSelangor Darul Ehsan",
    Tel: "03- 6189 0750, 6189 9780, 6189 6914",
    Fax: "03- 6189 9781",
    Email: "info@kimfoom.com.my",
    Area: "BATU CAVES",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 545,
    Name: "Kim Sang Auto Repair Sdn Bhd",
    Address:
      "JK 38 BC 43, Batu 10\nJalan Cheras\n43200 Kajang\nSelangor Darul Ehsan",
    Tel: "03- 9074 4227 & 9075 5229",
    Fax: "03- 9076 6228",
    Email: "kimsangmotor@hotmail.com",
    Area: "KAJANG",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 546,
    Name: "Kim Sing Motor Works Sdn Bhd",
    Address:
      "No. 62. Jalan PBS 14/4, Taman\nPerindustrian\nBukit Serdang\n43300 Seri Kembangan\nSelangor Darul Ehsan",
    Tel: "03- 8941 6998\n03- 8941 9255",
    Fax: "03- 8941 7998",
    Email: "kimsmw@gmail.com",
    Area: "SERI KEMBANGAN",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 547,
    Name: "Kim Soon Motors Sdn Bhd",
    Address:
      "Lot 650, SL 3, Jalan Subang 1\nTaman Industri Sg. Penaga\n47500 Subang Jaya\nSelangor Darul Ehsan",
    Tel: "03- 5632 3698 03- 5632 3699",
    Fax: "03- 5632 3700",
    Email: "admin@kimsoonmotors.com.my",
    Area: "SUBANG JAYA",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 548,
    Name: "Lee Hing Motors Sdn Bhd",
    Address:
      "Lot 624, 7 1/4 Miles\nJalan Ipoh\n68100 Batu Caves\nSelangor Darul Ehsan",
    Tel: "03- 6188 4355",
    Fax: "03- 6185 3518",
    Email: "leehing@live.com",
    Area: "BATU CAVES",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 549,
    Name: "Makro Jaya Auto & Service (M) Sdn Bhd",
    Address:
      "Lot 4672 , Bahagian B, (Lot 1-3)\nJalan Indah 3, Kg. Selayang Indah\n68100 Batu Caves\nSelangor Darul Ehsan",
    Tel: "03- 6137 2920, 61379395",
    Fax: "03- 6138 4702",
    Email: "makro.jaya@yahoo.com",
    Area: "BATU CAVES",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 550,
    Name: "Meng Ho Auto Services Sdn Bhd",
    Address:
      "No. 3, Jalan PJU 3/46,\nSunway Damansara Technology Park\n47800 Petaling Jaya\nSelangor Darul Ehsan",
    Tel: "03- 7729 8319\n03- 7722 4073",
    Fax: "03- 7725 8319",
    Email: "mengho@live.com",
    Area: "PETALING JAYA",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 551,
    Name: "New Sunrise Auto Sdn Bhd",
    Address:
      "No.11, Jalan TIB 1 / 21\nTaman Industri Bolton\n68100 Batu Caves\nSelangor Darul Ehsan",
    Tel: "03- 6189 1362",
    Fax: "03- 6188 3457",
    Email: "sunriseworkshop1999@yahoo.com.sg\nnewsunriseauto@hotmail.com",
    Area: "BATU CAVES",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 552,
    Name: "Nikamajujaya Motor Sdn Bhd",
    Address:
      "Lot 46221, Batu 10, Jalan Sungai Tua,\n68100 Batu Caves\nSelangor Darul Ehsan",
    Tel: "03- 6188 7173\n012- 388 6643",
    Fax: "03- 6189 7173",
    Email: "nikamajujaya@yahoo.com",
    Area: "BATU CAVES",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 553,
    Name: "Ong Kok Wah Motor Repair Sdn. Bhd.",
    Address:
      "52, Jln TS 6\nTaman Industri Subang\n47510 Subang Jaya\nSelangor Darul Ehsan",
    Tel: "03- 5637 3766/ 67",
    Fax: "03- 5637 3768",
    Email: "okwmotor@hotmail.com",
    Area: "SUBANG JAYA",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 554,
    Name: "P.K.W. Motor Repairers Sdn Bhd",
    Address:
      "No 78 Jalan 2/10B\nSpring Crest Industry Park\n68100 Batu Caves\nSelangor Darul Ehsan",
    Tel: "03-6177 8859",
    Fax: "03- 61883 794",
    Email: "pkwmotor@yahoo.com",
    Area: "BATU CAVES",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 555,
    Name: "Planet Car Sdn Bhd",
    Address:
      "No.2,4,6 Jalan Utama 1/15\nTmn Perindustrian Puchong Utama,\nseksyen 1\n47100 Puchong\nSelangor Darul Ehsan",
    Tel: "03- 8061 1132",
    Fax: "03- 8062 1132",
    Email: "keong6891@hotmail.com\nplanetcarsdnbhd@hotmail.com",
    Area: "PUCHONG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 556,
    Name: "Poh Kin Motor Works Sdn Bhd",
    Address:
      "PT3456, Jalan Tengas 1B\nKawasan Perindustrian Tengas\nUlu Yam Bharu\n44300 Batang Kali\nSelangor Darul Ehsan\n",
    Tel: "03- 6075 1106",
    Fax: "03- 6075 2106",
    Email: "pkmwtlt@yahoo.com",
    Area: "BATANG KALI",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 557,
    Name: "Popular Auto & Services Sdn Bhd",
    Address:
      "55 Solok Sultan Mohamad 1\nPusat Perdagangan Bandar Sultan\nSuleiman 4,Pelabuhan Utara,\n42000 Pelabuhan Klang\nSelangor Darul Ehsan",
    Tel: "03-3176 0588/ 016-2631158/ 012-3601158",
    Fax: "03-3176 0588",
    Email: "passb8@gmail.com",
    Area: "PELABUHAN KLANG",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 558,
    Name: "Rasa Soon Fatt Workshop Sdn Bhd",
    Address: "No. 2280, Batu 34\nJalan Ipoh\n44200 Rasa\nSelangor Darul Ehsan",
    Tel: "03- 6057 2890/ 03- 6057 1608",
    Fax: "03- 6057 4355",
    Email: "laiusc@yahoo.com.my\nadmin@rasasoonfatt.com",
    Area: "RASA",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 559,
    Name: "Rawang Leong Spray Workshop Sdn Bhd",
    Address:
      "Lot Pt 3471, Jalan Monorail\nMukim Serendah Dalam, Hulu Selangor\n48200 Serendah\nSelangor Darul Ehsan",
    Tel: "03- 6091 5418\n03- 6093 3591",
    Fax: "03- 6091 6634",
    Email: "rawangleongspray@gmail.com",
    Area: "SERENDAH",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 560,
    Name: "Rebond Motor Sdn Bhd",
    Address:
      "34, Jalan Industri USJ 1/1\nTaman Perindustrian USJ 1\n47600 Subang Jaya\nSelangor Darul Ehsan",
    Tel: "03- 8023 6000 / 03- 8023 6660",
    Fax: "03- 8023 6600",
    Email: "rebondmotor@yahoo.com\nomweng@gmail.com",
    Area: "SUBANG JAYA",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 561,
    Name: "Setia Gemilang Auto Sdn Bhd",
    Address:
      "Lot 7959, Jalan Sungai Buloh\nOff Kampung Melayu Subang, Seksyen U6\n40100 Shah Alam\nSelangor Darul Ehsan",
    Tel: "03- 7845 6888",
    Fax: "03- 7832 2555",
    Email: "claims@gemilangauto.com.my\nsetiagemilangauto@sq.net.my",
    Area: "SHAH ALAM",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 562,
    Name: "Sin Hin Workshop Sdn Bhd",
    Address:
      "68, 66 & 64, Jln PBS 14/10\nTaman Perindustrian Bukit Serdang\n43300 Seri Kembangan\nSelangor Darul Ehsan",
    Tel: "03- 8941 4215",
    Fax: "03- 8941 4216",
    Email: "sinhin_my@yahoo.com",
    Area: "SERI KEMBANGAN",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 563,
    Name: "Sin Huat Auto Repairs Sdn Bhd",
    Address:
      "Lot 9240, 5 1/2\nMain Road Sungai Lias\n45300 Sungai Besar\nSelangor Darul Ehsan",
    Tel: "03- 3224 1373",
    Fax: "03- 3224 1439",
    Email: "sinhuat_motor0130@yahoo.com",
    Area: "SUNGAI BESAR",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 564,
    Name: "Song Meng Workshop & Towing Service Sdn Bhd",
    Address:
      "Lot Pt 132, Batu 15, Jalan Klang Banting\n42600 Jenjarom\nSelangor Darul Ehsan",
    Tel: "03- 3191 3840\n03- 3191 2333",
    Fax: "03- 3191 3519",
    Email: "songmengworkshoptowingservice@hotmail.com\nsmsee3840@outlook.com",
    Area: "JENJAROM",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 565,
    Name: "SPS Motor Workshop Sdn Bhd",
    Address:
      "19 & 21, JALAN TS 6/5,\nSubang Industrial Park\n47510 Subang Jaya\nSelangor Darul Ehsan",
    Tel: "03- 5621 6250",
    Fax: "03- 5621 5250",
    Email: "spsmotor@yahoo.com\ninfo@spsmw.com",
    Area: "SUBANG JAYA",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 566,
    Name: "Sun Refinishing Centre Sdn Bhd",
    Address:
      "Lot 839A, Jalan Persiaran Subang\nTaman Perindustrian Subang\n47600\nSubang Jaya\nSelangor Darul Ehsan",
    Tel: "03- 8023 0599(Hunting Line)",
    Fax: "03- 8023 6599",
    Email: "sunrc1@hotmail.com",
    Area: "SUBANG JAYA",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 567,
    Name: "Syarikat Motor Sin Wing Soon (KLG) Sdn Bhd",
    Address:
      "Lot 21233, Batu 3\nJalan Kapar\n41400 Klang\nSelangor Darul Ehsan",
    Tel: "03- 3341 0290",
    Fax: "03- 3341 0869",
    Email: "claim@swsmotor.com.my",
    Area: "KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 568,
    Name: "Tasik Wangsa Sdn Bhd",
    Address:
      "No 1-11, Lorong Keluli 1D\nKaw Ind Bukit Raja Selatan\n40800 Shah Alam\nSelangor Darul Ehsan",
    Tel: "03- 3341 2891",
    Fax: "03- 3341 2890",
    Email: "twangsa@hotmail.com",
    Area: "SHAH ALAM",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 569,
    Name: "Teck Seng Spray Painting Sdn Bhd",
    Address:
      "No. 18, Jalan SP 4/3\nSubang Perdana Industrial Park\n40150 Shah Alam\nSelangor Darul Ehsan",
    Tel: "03-7847 1773",
    Fax: "03- 7847 1776",
    Email: "teckseng18@gmail.com",
    Area: "SHAH ALAM",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 570,
    Name: "Teng Lai Motor Sdn Bhd",
    Address:
      "Batu 7 1/2\nJalan Besar\n45500 Tanjong Karang\nSelangor Darul Ehsan",
    Tel: "03- 3269 8063",
    Fax: "03- 3269 5398",
    Email: "tenglaimotorsdnbhd@gmail.com",
    Area: "TANJONG KARANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 571,
    Name: "Thian Hoe Motor Sdn Bhd",
    Address:
      "No. 12A -16, Jalan 2/6\nTaman Industri Selesa Jaya\n43300 Balakong\nSelangor Darul Ehsan",
    Tel: "03- 8961 3799\n03- 8964 0658",
    Fax: "03- 8961 6058",
    Email: "thianhoemotor@outlook.com",
    Area: "BALAKONG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 572,
    Name: "Ultra-Tune Sdn Bhd",
    Address:
      "No.27 Jalan Pemberita U1/49\nTemasya Ind. Park\nSection U1, Glenmarie\n40150 Shah Alam\nSelangor Darul Ehsan",
    Tel: "03- 7620 2238",
    Fax: "03- 7620 1638",
    Email: "info@ultratune.com.my",
    Area: "SHAH ALAM",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 573,
    Name: "USAI EP Motor Sdn Bhd",
    Address:
      "Lot 6B, & 6C Jalan Kilang B\nOff Jalan Kilang\n46050 Petaling Jaya\nSelangor Darul Ehsan",
    Tel: "03-7785 1200",
    Fax: "03-7784 4100",
    Email: "usaiep31@gmail.com",
    Area: "PETALING JAYA",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 574,
    Name: "Victory Auto Repair Sdn Bhd",
    Address:
      "PT No. 30219, Bt. 5, Jalan Johan Setia,\n42450 Shah Alam\nSelangor Darul Ehsan",
    Tel: "03- 5161 3000\n012- 211 7111",
    Fax: "03- 5161 6066",
    Email: "victoryautorepair@gmail.com",
    Area: "SHAH ALAM",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 575,
    Name: "Weng Heng Mudguard & Spraying Sdn Bhd",
    Address:
      "35 & 37, Jalan TS 6/4, Taman Industri\nSubang Jaya\nSubang Jaya\n47510 Petaling Jaya\nSelangor Darul Ehsan",
    Tel: "03- 8081 6959",
    Fax: "03- 5632 6166",
    Email: "wengms37@hotmail.com",
    Area: "PETALING JAYA",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 576,
    Name: "Yuen Yik Auto Sdn Bhd",
    Address:
      "No. 49, Lorong Perusahaan Ringan 1,\nLight Industrial Area, Sri Gombak\n68100 Batu Caves\nSelangor Darul Ehsan",
    Tel: "03- 6188 1129",
    Fax: "03- 6186 1129",
    Email: "yuenyikauto@yahoo.com",
    Area: "BATU CAVES",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 754,
    Name: "Ming Soon Car Cares Sdn Bhd",
    Address:
      "13, Jalan TPP 1/1A\nTaman Perindustrian Puchong\n47100  Puchong\nSelangor",
    Tel: "03- 8090 9129",
    Fax: null,
    Email: "mingsoonccsb@gmail.com",
    Area: "PUCHONG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 767,
    Name: "Ker Auto World Sdn Bhd",
    Address:
      "Lot 13461, \nJalan Kapar Baru 2 Kaw 19,\n41400 Klang,\nSelangor Darul Ehsan.",
    Tel: "03- 3359 5618",
    Fax: "03- 3359 5618",
    Email: "kerautoworld@gmail.com",
    Area: "KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 773,
    Name: "Soon Lee SL Workshop Sdn Bhd",
    Address:
      "Lot PT25998 & 25999,\nJalan Perusahaan Dua,\nTaman Industry Selesa Jaya\n43300 Balakong\nSelangor",
    Tel: "03- 8964 9600",
    Fax: "03- 8964 9700",
    Email: "alex.yap@live.com.my",
    Area: "BALAKONG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 951,
    Name: "Success Car Refurnishing Sdn Bhd ",
    Address:
      "Lot 893 C & D, Jalan Subang 9, \nTaman Industri, Sungai Penaga, \n47630 Subang Jaya, \nSelangor.",
    Tel: "03- 8081 7526",
    Fax: "03- 8081 0526",
    Email: "scr_sdnbhd@hotmail.com",
    Area: "Subang Jaya",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 952,
    Name: "PJLM Auto Sdn Bhd ",
    Address: "No.7 & 9, Lorong 51A/227B, \n46100 Petaling Jaya, \nSelangor",
    Tel: "03- 7954 1995\n03- 7954 2148",
    Fax: "03- 7954 2289",
    Email: "motorliew@gmail.com",
    Area: "Petaling Jaya",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1367,
    Name: "Setia Gemilang Auto Sdn Bhd",
    Address:
      "Lot 7959 & 7960, Jalan Sungai Buloh, \nOff Kampung Melayu Subang, \nSeksyen U6, 40100 Shah Alam, \nSelangor Darul Ehsan. ",
    Tel: "03- 7845 6888",
    Fax: "03- 7832 2929",
    Email: "setiagemilangauto@sq.net.my",
    Area: "SHAH ALAM",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 495,
    Name: "Yoong Lee Car-Tech Sdn Bhd",
    Address:
      "T 2138K, Kawasan Perindustrian\nChendering\n21080\nKuala Terengganu\nTerengganu Darul Iman",
    Tel: "09- 917 1407\n09- 6172 407",
    Fax: "09- 6175 407",
    Email: "yoonglee01@yahoo.com.my",
    Area: "KUALA TERENGGANU",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 496,
    Name: "Bengkel Kereta Kemaman Sdn Bhd",
    Address:
      "Lot 6273, Kawasan Perindustrian Jakar 1\n24000 Kemaman\nTerengganu",
    Tel: "09- 859 2067",
    Fax: "09- 859 3677",
    Email: "bkk_spray@hotmail.com",
    Area: "KEMAMAN",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 497,
    Name: "Brigstone Auto Maju Workshop Sdn Bhd",
    Address: "Lot. 3048 Batu 5 ½, Jalan Paka\n23000 Dungun\nTerengganu",
    Tel: "09- 845 3803\n09- 845 8268",
    Fax: "09- 845 3801",
    Email: "automaju88@gmail.com",
    Area: "DUNGUN",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 498,
    Name: "East Coast Spray & Repair Sdn Bhd",
    Address:
      "No.7 Lot 5820, Kawasan Perindustrian\nJakar ll\n24000 Kemaman\nTerengganu",
    Tel: "09- 859 5228\n09- 858 5788",
    Fax: null,
    Email: "estcoastsr@gmail.com",
    Area: "KEMAMAN",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 499,
    Name: "Bengkel Sinar Ady Sdn Bhd",
    Address:
      "Tanah Lot, Rawai\nBukit Payong\n21400 Marang\nTerengganu Darul Iman",
    Tel: "09- 619 9049",
    Fax: "09- 619 9049",
    Email: "b_sinarady@yahoo.com",
    Area: "MARANG",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 500,
    Name: "Keong Workshop (Terengganu) Sdn Bhd",
    Address:
      "PT 2989, Kawasan Perindustrian\nChendering\n21080 Kuala Terengganu\nTerengganu Darul Iman",
    Tel: "09- 617 1198",
    Fax: "09- 617 0198",
    Email: "keongtrg@gmail.com\nkeong_workshop@hotmail.com",
    Area: "TERENGGANU",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 501,
    Name: "RZ Workshop Sdn Bhd",
    Address:
      "1724-A, Pekan Sari Tepoh\nJalan Kelantan\n21060 Kuala Terengganu\nTerengganu Darul Iman",
    Tel: "09- 662 5357/ 019- 984 8588",
    Fax: "09- 662 5357",
    Email: "rzworkshopsb@gmail.com",
    Area: "KUALA TERENGGANU",
    Status: 0,
    State: "Terrenganu",
  },
];
